import { SID } from "@securitize/domain";

const translationKeys = {
  REGISTRATION_NEXT: "Texts.registration-next",
  REGISTRATION_ACCOUNT_EXISTS: "Texts.registration-account-exists",
  REGISTRATION_LOGIN: "Texts.registration-login",

  REGISTRATION_STEP_NAME_TITLE: "Texts.registration-step-name-title",
  REGISTRATION_STEP_NAME_SUBTITLE: "Texts.registration-step-name-subtitle",
  REGISTRATION_STEP_PHONE_TITLE: "Texts.registration-step-phone-title",
  REGISTRATION_STEP_PHONE_SUBTITLE: "Texts.registration-step-phone-subtitle",
  REGISTRATION_STEP_TYPE_TITLE: "Texts.registration-step-type-title",
  REGISTRATION_STEP_ENTITY_TITLE: "Texts.registration-step-entity-title",

  REGISTRATION_FIRST_NAME: "Texts.registration-first-name",
  REGISTRATION_LAST_NAME: "Texts.registration-last-name",

  REGISTRATION_RESIDENCE_COUNTRY: "Texts.registration-residence-country",
  REGISTRATION_RESIDENCE_STATE: "Texts.registration-residence-state",
  REGISTRATION_PHONE: "Texts.registration-phone",

  INDIVIDUAL: "Texts.individual",
  ENTITY: "Texts.entity",
  INDIVIDUAL_DESCRIPTION: "Texts.individual-description",
  ENTITY_DESCRIPTION: "Texts.entity-description",

  REGISTRATION_ENTITY_NAME: "Texts.registration-entity-name",
  REGISTRATION_ENTITY_COUNTRY: "Texts.registration-entity-country",
  REGISTRATION_ENTITY_STATE: "Texts.registration-entity-state",

  REGISTRATION_VALIDATION_REQUIRED_FIRST_NAME:
    "Texts.registration-validation-required-first-name",
  REGISTRATION_VALIDATION_INVALID_NAME:
    "Texts.registration-validation-invalid-name",
  REGISTRATION_VALIDATION_REQUIRED_LAST_NAME:
    "Texts.registration-validation-required-last-name",
  REGISTRATION_VALIDATION_REQUIRED_RESIDENCE_COUNTRY:
    "Texts.registration-validation-required-residence-country",
  REGISTRATION_VALIDATION_REQUIRED_RESIDENCE_STATE:
    "Texts.registration-validation-required-residence-state",
  REGISTRATION_VALIDATION_REQUIRED_PHONE:
    "Texts.registration-validation-required-phone",
  REGISTRATION_VALIDATION_INVALID_PHONE:
    "Texts.registration-validation-invalid-phone",
  REGISTRATION_VALIDATION_REQUIRED_ACCOUNT_TYPE:
    "Texts.registration-validation-required-account-type",
  REGISTRATION_VALIDATION_INVALID_ENTITY_NAME:
    "Texts.registration-validation-invalid-entity-name",
  REGISTRATION_VALIDATION_REQUIRED_ENTITY_NAME:
    "Texts.registration-validation-required-entity-name",
  REGISTRATION_VALIDATION_REQUIRED_ENTITY_COUNTRY:
    "Texts.registration-validation-required-entity-country",
  REGISTRATION_VALIDATION_REQUIRED_ENTITY_STATE:
    "Texts.registration-validation-required-entity-state",
  REGISTRATION_VALIDATION_MINIMUM_LENGTH:
    "Texts.registration-validation-minimum-length",
  REGISTRATION_VALIDATION_MAXIMUM_LENGTH:
    "Texts.registration-validation-maximum-length",

  // Phone Verification Modal
  PHONE_VERIFICATION_TITLE: "Texts.phone-verification-modal-title",
  PHONE_VERIFICATION_PHONE_STEP_SUBTITLE:
    "Texts.phone-verification-modal-phone-step-subtitle",
  PHONE_VERIFICATION_PHONE_STEP_FOOTER_CONSENT:
    "Texts.phone-verification-modal-phone-step-footer-consent",
  PHONE_VERIFICATION_PHONE_STEP_FOOTER:
    "Texts.phone-verification-modal-phone-step-footer",
  PHONE_VERIFICATION_PHONE_STEP_CTA_BUTTON:
    "Texts.phone-verification-modal-phone-step-cta-button",
  PHONE_VERIFICATION_CODE_STEP_SUBTITLE:
    "Texts.phone-verification-modal-code-step-subtitle",
  PHONE_VERIFICATION_CODE_STEP_FOOTER:
    "Texts.phone-verification-modal-code-step-footer",
  PHONE_VERIFICATION_CODE_STEP_CTA_BUTTON:
    "Texts.phone-verification-modal-code-step-cta-button",
  PHONE_VERIFICATION_CODE_STEP_NEW_CODE_REQUEST:
    "Texts.phone-verification-modal-code-step-new-code-request",
  PHONE_VERIFICATION_CODE_STEP_NEW_CODE_REQUEST_BUTTON:
    "Texts.phone-verification-modal-code-step-new-code-request-button",
  PHONE_VERIFICATION_CODE_STEP_CODE_RESENT:
    "Texts.phone-verification-modal-code-step-new-code-resent",
  PHONE_VERIFICATION_PHONE_INPUT_LABEL:
    "Texts.phone-verification-modal-phone-input-label",
  PHONE_VERIFICATION_PHONE_INPUT_EMPTY_HELPER_TEXT:
    "Texts.phone-verification-modal-phone-input-empty-helper-text",
  PHONE_VERIFICATION_PHONE_INPUT_INVALID_HELPER_TEXT:
    "Texts.phone-verification-modal-phone-input-invalid-helper-text",
  PHONE_VERIFICATION_CODE_INPUT_EMPTY_HELPER_TEXT:
    "Texts.phone-verification-modal-code-input-empty-helper-text",
  PHONE_VERIFICATION_CODE_INPUT_INVALID_HELPER_TEXT:
    "Texts.phone-verification-modal-code-input-invalid-helper-text",
  PHONE_VERIFICATION_NUMBER_VERIFIED:
    "Texts.phone-verification-modal-number-verified",
  PHONE_VERIFICATION_ERROR_GENERATING_CODE:
    "Texts.phone-verification-modal-error-generating-code",

  // Snackbar
  SNACKBAR_GENERAL_ERROR_BUTTON_TEXT:
    "Texts.snackbar-general-error-button-text",

  // User Menu
  USER_MENU_INVESTOR_STATUS_VERIFIED:
    "Texts.user-menu-investor-status-verified",
  USER_MENU_INVESTOR_STATUS_PENDING: "Texts.user-menu-investor-status-pending",
  USER_MENU_INVESTOR_STATUS_DOCUMENTS_EXPIRED:
    "Texts.user-menu-investor-status-documents-expired",
  USER_MENU_INVESTOR_STATUS_BLOCKED: "Texts.user-menu-investor-status-blocked",
  USER_MENU_INVESTOR_STATUS_UPDATES_REQUIRED:
    "Texts.user-menu-investor-status-updates-required",
  USER_MENU_INVESTOR_STATUS_NOT_VERIFIED:
    "Texts.user-menu-investor-status-not-verified",
  USER_MENU_INVESTOR_STATUS_EXPIRED: "Texts.user-menu-investor-status-expired",
  USER_MENU_INVESTOR_STATUS_SERVICE_DENIED:
    "Texts.user-menu-investor-status-service-denied",

  USER_MENU_CREATE_ENTITY_ACCOUNT: "Texts.user-menu-create-entity-account",
  CREATE_ENTITY_MODAL_TITLE: "Texts.create-entity-modal-title",
  CREATE_ENTITY_QUOTA_EXCEEDED: "Errors.entity-quota-exceeded",
  ADD_ENTITY_BUTTON: "Texts.add-entity-button",
  ADD_ENTITY_BUTTON_IN_PROGRESS: "Texts.add-entity-button-in-progress",

  USER_MENU_ERROR_LOADING_INVESTORS: "Texts.user-menu-error-loading-investors",
  USER_MENU_LOADING_INVESTORS: "Texts.user-menu-loading-investors",

  // Profile
  PROFILE_TITLE: "Texts.profile-title",
  PROFILE_PERSONAL_INFORMATION_TAB_TITLE:
    "Texts.profile-personal-information-tab-title",
  PROFILE_ENTITY_INFORMATION_TAB_TITLE:
    "Texts.profile-entity-information-tab-title",
  PROFILE_TAX_CENTER_TAB_TITLE: "Texts.profile-tax-center-tab-title",
  PROFILE_DOCUMENT_CENTER_TAB_TITLE: "Texts.profile-document-center-tab-title",
  PROFILE_DOCUMENTS_TAB_TITLE: "Texts.profile-documents-tab-title",
  PROFILE_KEY_PARTIES_TAB_TITLE: "Texts.profile-key-parties-tab-title",
  PROFILE_INVESTMENT_PROFILE_TAB_TITLE:
    "Texts.profile-investment-profile-tab-title",
  PROFILE_SETTINGS_TAB_TITLE: "Texts.profile-settings-tab-title",
  PROFILE_AUTHORIZED_MEMBERS_TAB_TITLE:
    "Texts.profile-authorized-members-tab-title",
  PROFILE_ERROR_TITLE: "Texts.profile-error-title",
  PROFILE_ERROR_SUBTITLE: "Texts.profile-error-subtitle",
  PROFILE_ERROR_SUBTITLE_WITH_CODE: "Texts.profile-error-subtitle-with-code",
  PROFILE_ERROR_ALERT: "Texts.profile-error-alert",
  PROFILE_ERROR_CTA: "Texts.profile-error-cta",
  PROFILE_ERROR_CODE_COPIED: "Texts.profile-error-code-copied",
  PROFILE_ERROR_FOOTER: "Texts.profile-error-footer",

  PROFILE_CONTENT_RESTRICTED_TITLE: "Texts.profile-content-restricted-title",
  PROFILE_CONTENT_RESTRICTED_SUBTITLE:
    "Texts.profile-content-restricted-subtitle",
  PROFILE_CONTENT_RESTRICTED_COMMENT:
    "Texts.profile-content-restricted-comment",
  PROFILE_CONTENT_RESTRICTED_CTA: "Texts.profile-content-restricted-cta",
  PROFILE_CONTENT_RESTRICTED_ALERT: "Texts.profile-content-restricted-alert",
  PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_TITLE:
    "Texts.profile-content-restricted-user-verification-title",
  PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_SUBTITLE:
    "Texts.profile-content-restricted-user-verification-subtitle",
  PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_COMMENT:
    "Texts.profile-content-restricted-user-verification-comment",
  PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_CTA:
    "Texts.profile-content-restricted-user-verification-cta",
  PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_ALERT:
    "Texts.profile-content-restricted-user-verification-alert",

  // Personal Information
  PROFILE_PERSONAL_INFORMATION_TITLE:
    "Texts.profile-personal-information-title",
  PROFILE_PERSONAL_INFORMATION_SUBTITLE:
    "Texts.profile-personal-information-subtitle",

  PROFILE_PERSONAL_INFORMATION_EMPTY_TITLE:
    "Texts.profile-personal-information-empty-title",
  PROFILE_PERSONAL_INFORMATION_EMPTY_SUBTITLE:
    "Texts.profile-personal-information-empty-subtitle",
  PROFILE_PERSONAL_INFORMATION_EMPTY_CTA:
    "Texts.profile-personal-information-empty-cta",
  PROFILE_PERSONAL_INFORMATION_EMPTY_COMMENT:
    "Texts.profile-personal-information-empty-comment",

  PROFILE_PERSONAL_INFORMATION_PERSONAL_DETAILS_CARD_TITLE:
    "Texts.profile-personal-information-personal-details-card-title",
  PROFILE_PERSONAL_INFORMATION_PERSONAL_DETAILS_CARD_SUBTITLE:
    "Texts.profile-personal-information-personal-details-card-subtitle",
  PROFILE_PERSONAL_INFORMATION_PERSONAL_DETAILS_CARD_FOOTER:
    "Texts.profile-personal-information-personal-details-card-footer",
  PROFILE_PERSONAL_INFORMATION_ADDRESS_CARD_TITLE:
    "Texts.profile-personal-information-address-card-title",
  PROFILE_PERSONAL_INFORMATION_ADDRESS_CARD_SUBTITLE:
    "Texts.profile-personal-information-address-card-subtitle_v2",
  PROFILE_PERSONAL_INFORMATION_ADDRESS_CARD_FOOTER:
    "Texts.profile-personal-information-address-card-footer",
  PROFILE_PERSONAL_INFORMATION_TAX_CARD_TITLE:
    "Texts.profile-personal-information-tax-card-title",
  PROFILE_PERSONAL_INFORMATION_TAX_CARD_SUBTITLE:
    "Texts.profile-personal-information-tax-card-subtitle",
  PROFILE_PERSONAL_INFORMATION_TAX_CARD_FOOTER:
    "Texts.profile-personal-information-tax-card-footer",
  PROFILE_PERSONAL_INFORMATION_TAX_CARD_TOOLTIP:
    "Texts.profile-personal-information-tax-card-tooltip_v2",

  PROFILE_PERSONAL_INFORMATION_FIELDS_FIRST_NAME:
    "Texts.profile-personal-information-fields-first-name",
  PROFILE_PERSONAL_INFORMATION_FIELDS_MIDDLE_NAME:
    "Texts.profile-personal-information-fields-middle-name",
  PROFILE_PERSONAL_INFORMATION_FIELDS_LAST_NAME:
    "Texts.profile-personal-information-fields-last-name",
  PROFILE_PERSONAL_INFORMATION_FIELDS_BIRTHDATE:
    "Texts.profile-personal-information-fields-birthdate",
  PROFILE_PERSONAL_INFORMATION_FIELDS_ADDRESS:
    "Texts.profile-personal-information-fields-address",
  PROFILE_PERSONAL_INFORMATION_FIELDS_ADDITIONAL_INFO:
    "Texts.profile-personal-information-fields-additional-info",
  PROFILE_PERSONAL_INFORMATION_FIELDS_CITY:
    "Texts.profile-personal-information-fields-city",
  PROFILE_PERSONAL_INFORMATION_FIELDS_POSTAL_CODE:
    "Texts.profile-personal-information-fields-postal-code",
  PROFILE_PERSONAL_INFORMATION_FIELDS_COUNTRY:
    "Texts.profile-personal-information-fields-country",
  PROFILE_PERSONAL_INFORMATION_FIELDS_STATE:
    "Texts.profile-personal-information-fields-state",
  PROFILE_PERSONAL_INFORMATION_FIELDS_TAX_RESIDENCE:
    "Texts.profile-personal-information-fields-tax-residence",
  PROFILE_PERSONAL_INFORMATION_FIELDS_TAX_ID:
    "Texts.profile-personal-information-fields-tax-id",

  // Entity information
  PROFILE_ENTITY_INFORMATION_TITLE: "Texts.profile-entity-information-title",
  PROFILE_ENTITY_INFORMATION_SUBTITLE:
    "Texts.profile-entity-information-subtitle",
  PROFILE_ENTITY_INFORMATION_EMPTY_TITLE:
    "Texts.profile-entity-information-empty-title",
  PROFILE_ENTITY_INFORMATION_EMPTY_SUBTITLE:
    "Texts.profile-entity-information-empty-subtitle",
  PROFILE_ENTITY_INFORMATION_EMPTY_CTA:
    "Texts.profile-entity-information-empty-cta",
  PROFILE_ENTITY_INFORMATION_EMPTY_COMMENT:
    "Texts.profile-entity-information-empty-comment",

  PROFILE_ENTITY_INFORMATION_ENTITY_INFORMATION_CARD_TITLE:
    "Texts.profile-entity-information-entity-information-card-title",
  PROFILE_ENTITY_INFORMATION_ENTITY_INFORMATION_CARD_SUBTITLE:
    "Texts.profile-entity-information-entity-information-card-subtitle",
  PROFILE_ENTITY_INFORMATION_ENTITY_INFORMATION_CARD_FOOTER:
    "Texts.profile-entity-information-entity-information-card-footer",
  PROFILE_ENTITY_INFORMATION_ENTITY_INFORMATION_CARD_TAX_ID_TOOLTIP:
    "Texts.profile-entity-information-entity-information-card-tax-id-tooltip_v2",
  PROFILE_ENTITY_INFORMATION_ENTITY_INFORMATION_CARD_DBA_TOOLTIP:
    "Texts.profile-entity-information-entity-information-card-dba-tooltip_v2",
  PROFILE_ENTITY_INFORMATION_BUSINESS_INFORMATION_CARD_TITLE:
    "Texts.profile-entity-information-business-information-card-title",
  PROFILE_ENTITY_INFORMATION_BUSINESS_INFORMATION_CARD_SUBTITLE:
    "Texts.profile-entity-information-business-information-card-subtitle",
  PROFILE_ENTITY_INFORMATION_BUSINESS_INFORMATION_CARD_FOOTER:
    "Texts.profile-entity-information-business-information-card-footer",
  PROFILE_ENTITY_INFORMATION_BUSINESS_INFORMATION_CARD_LEI_TOOLTIP:
    "Texts.profile-entity-information-business-information-card-lei-tooltip_v2",
  PROFILE_ENTITY_INFORMATION_ADDRESS_CARD_TITLE:
    "Texts.profile-entity-information-address-card-title",
  PROFILE_ENTITY_INFORMATION_ADDRESS_CARD_SUBTITLE:
    "Texts.profile-entity-information-address-card-subtitle_v2",
  PROFILE_ENTITY_INFORMATION_ADDRESS_CARD_FOOTER:
    "Texts.profile-entity-information-address-card-footer",

  PROFILE_ENTITY_INFORMATION_FIELDS_ENTITY_NAME:
    "Texts.profile-entity-information-fields-entity-name",
  PROFILE_ENTITY_INFORMATION_FIELDS_ENTITY_TYPE:
    "Texts.profile-entity-information-fields-entity-type",
  PROFILE_ENTITY_INFORMATION_FIELDS_INCORPORATION_DATE:
    "Texts.profile-entity-information-fields-incorporation-date",
  PROFILE_ENTITY_INFORMATION_FIELDS_TAX_ID:
    "Texts.profile-entity-information-fields-tax-id",
  PROFILE_ENTITY_INFORMATION_FIELDS_DBA:
    "Texts.profile-entity-information-fields-dba",
  PROFILE_ENTITY_INFORMATION_FIELDS_WEBSITE:
    "Texts.profile-entity-information-fields-website",
  PROFILE_ENTITY_INFORMATION_FIELDS_LEI_CODE:
    "Texts.profile-entity-information-fields-lei-code",
  PROFILE_ENTITY_INFORMATION_FIELDS_SOURCE_OF_FUNDS:
    "Texts.profile-entity-information-fields-source-of-funds",
  PROFILE_ENTITY_INFORMATION_FIELDS_LINE_OF_BUSINESS:
    "Texts.profile-entity-information-fields-line-of-business",

  // Entity information enabled form
  PROFILE_ENTITY_INFORMATION_FIELDS_GENERIC_SECTION_ERROR:
    "Texts.profile-entity-information-fields-generic-section-error",
  PROFILE_ENTITY_INFORMATION_FIELDS_ENTITY_TYPE_PLACEHOLDER:
    "Texts.profile-entity-information-fields-entity-type-placeholder",
  PROFILE_ENTITY_INFORMATION_CTA: "Texts.profile-entity-information-cta",
  PROFILE_ENTITY_INFORMATION_CTA_LOADING:
    "Texts.profile-entity-information-cta-loading",
  PROFILE_ENTITY_INFORMATION_FOOTER: "Texts.profile-entity-information-footer",
  PROFILE_ENTITY_INFORMATION_FIELDS_ENTITY_NAME_INVALID:
    "Texts.profile-business-information-fields-entity-name-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_LEI_CODE_REQUIRED_LABEL:
    "Texts.profile-business-information-fields-lei-code-required-label",
  PROFILE_ENTITY_INFORMATION_FIELDS_LEI_CODE_INVALID:
    "Texts.profile-business-information-fields-lei-code-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_LEI_CODE_LENGTH_ERROR:
    "Texts.profile-business-information-fields-lei-code-length_error",
  PROFILE_ENTITY_INFORMATION_FIELDS_WEBSITE_PLACEHOLDER:
    "Texts.profile-entity-information-fields-website-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_STREET_INVALID:
    "Texts.profile-entity-information-fields-street-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_STREET_PLACEHOLDER:
    "Texts.profile-entity-information-fields-street-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_CITY_INVALID:
    "Texts.profile-entity-information-fields-city-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_CITY_PLACEHOLDER:
    "Texts.profile-entity-information-fields-city-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_ZIP_INVALID:
    "Texts.profile-entity-information-fields-zip-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_ZIP_PLACEHOLDER:
    "Texts.profile-entity-information-fields-zip-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_STATE_PLACEHOLDER:
    "Texts.profile-entity-information-fields-state-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_WEBSITE_INVALID:
    "Texts.profile-entity-information-fields-website-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_INCORPORATION_DATE_FORMAT:
    "Texts.profile-entity-information-fields-incorporation-date-format",
  PROFILE_ENTITY_INFORMATION_FIELDS_INCORPORATION_DATE_INVALID:
    "Texts.profile-entity-information-fields-incorporation-date-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_INCORPORATION_DATE_PLACEHOLDER:
    "Texts.profile-entity-information-fields-incorporation-date-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_INCORPORATION_DATE_CONFIRM:
    "Texts.profile-entity-information-fields-incorporation-date-confirm",
  PROFILE_ENTITY_INFORMATION_FIELDS_INCORPORATION_DATE_CANCEL:
    "Texts.profile-entity-information-fields-incorporation-date-cancel",
  PROFILE_ENTITY_INFORMATION_FIELDS_TAX_ID_INVALID:
    "Texts.profile-entity-information-fields-tax-id-invalid",
  PROFILE_ENTITY_INFORMATION_FIELDS_ADDITIONAL_INFO_PLACEHOLDER:
    "Texts.profile-entity-information-fields-additional-info-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_SOURCE_OF_FUNDS_PLACEHOLDER:
    "Texts.profile-entity-information-fields-source-of-funds-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_LINE_OF_BUSINESS_PLACEHOLDER:
    "Texts.profile-entity-information-fields-line-of-business-placeholder",
  PROFILE_ENTITY_INFORMATION_FIELDS_COUNTRY_PLACEHOLDER:
    "Texts.profile-entity-information-fields-country-placeholder",

  PROFILE_ENTITY_TYPES_CORPORATION: "Texts.profile-entity-types-corporation",
  PROFILE_ENTITY_TYPES_LLC: "Texts.profile-entity-types-llc",
  PROFILE_ENTITY_TYPES_LIMITED_GENERAL_PARTNERSHIP:
    "Texts.profile-entity-types-limited-partnership/general-partnership",
  PROFILE_ENTITY_TYPES_REVOCABLE_TRUST:
    "Texts.profile-entity-types-revocable-trust",
  PROFILE_ENTITY_TYPES_IRREVOCABLE_TRUST:
    "Texts.profile-entity-types-irrevocable-trust",
  PROFILE_ENTITY_TYPES_NON_PROFIT_FOUNDATION:
    "Texts.profile-entity-types-non-profit-foundation",
  PROFILE_ENTITY_TYPES_FOR_PROFIT_FOUNDATION:
    "Texts.profile-entity-types-for-profit-foundation",
  PROFILE_ENTITY_TYPES_FUND: "Texts.profile-entity-types-fund",
  PROFILE_ENTITY_TYPES_JOINT_ACCOUNT:
    "Texts.profile-entity-types-joint-account",
  PROFILE_ENTITY_TYPES_OTHER: "Texts.profile-entity-types-other",

  // Documents
  PROFILE_DOCUMENTS_ENTITY_CARD_TITLE:
    "Texts.profile-documents-entity-card-title",
  PROFILE_DOCUMENTS_ENTITY_CARD_SUBTITLE:
    "Texts.profile-documents-entity-card-subtitle",
  PROFILE_DOCUMENTS_ENTITY_CARD_DISCLAIMER:
    "Texts.profile-documents-entity-card-disclaimer",
  PROFILE_DOCUMENTS_ENTITY_MISSING_ERROR:
    "Texts.profile-documents-entity-missing-error",
  PROFILE_DOCUMENTS_ENTITY_CTA: "Texts.profile-documents-entity-cta",
  PROFILE_DOCUMENTS_ENTITY_CTA_LOADING:
    "Texts.profile-documents-entity-cta-loading",
  PROFILE_DOCUMENTS_ENTITY_FOOTER: "Texts.profile-documents-entity-footer",
  PROFILE_DOCUMENTS_ENTITY_READ_ONLY_UPDATE_FOOTER:
    "Texts.profile-documents-entity-read-only-update-footer",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_TITLE:
    "Texts.profile-documents-entity-uploader-title",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_SUBTITLE:
    "Texts.profile-documents-entity-uploader-subtitle",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_CTA:
    "Texts.profile-documents-entity-uploader-cta",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_CTA_REMOVE:
    "Texts.profile-documents-entity-uploader-cta-remove",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_CTA_CANCEL:
    "Texts.profile-documents-entity-uploader-cta-cancel",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_DRAG_AND_DROP:
    "Texts.profile-documents-entity-uploader-drag-and-drop",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_REQUIRED:
    "Texts.profile-documents-entity-uploader-required",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_INVALID_FORMAT_ERROR:
    "Texts.profile-documents-entity-uploader-invalid-format-error",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_INVALID_SIZE_ERROR:
    "Texts.profile-documents-entity-uploader-invalid-size-error",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_GENERIC_ERROR:
    "Texts.profile-documents-entity-uploader-generic-error",
  PROFILE_DOCUMENTS_ENTITY_UPLOADER_REMOVE_SUCCESS:
    "Texts.profile-documents-entity-uploader-remove-success",
  PROFILE_DOCUMENTS_ENTITY_ADDITIONAL_DOCUMENT_REQUIRED:
    "Texts.profile-documents-entity-additional-document-required",

  // Authorized Members
  PROFILE_AUTHORIZED_MEMBERS_TITLE: "Texts.profile-authorized-members-title",
  PROFILE_AUTHORIZED_MEMBERS_SUBTITLE:
    "Texts.profile-authorized-members-subtitle",

  // Investment Profile
  PROFILE_INVESTMENT_PROFILE_TITLE: "Texts.profile-investment-profile-title",
  PROFILE_INVESTMENT_PROFILE_SUBTITLE:
    "Texts.profile-investment-profile-subtitle",
  PROFILE_INVESTMENT_PROFILE_CARD_TITLE:
    "Texts.profile-investment-profile-card-title",
  PROFILE_INVESTMENT_PROFILE_CARD_SUBTITLE:
    "Texts.profile-investment-profile-card-subtitle",
  PROFILE_INVESTMENT_PROFILE_CARD_CTA:
    "Texts.profile-investment-profile-card-cta",
  INVESTMENT_PROFILE_STATUS_IN_REVIEW:
    "Texts.investment-profile-status-in-review",
  INVESTMENT_PROFILE_STATUS_COMPLETED:
    "Texts.investment-profile-status-completed",
  INVESTMENT_PROFILE_STATUS_REJECTED:
    "Texts.investment-profile-status-rejected",
  PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_TITLE:
    "Texts.profile-investment-profile-accreditation-card-title",
  PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_SUBTITLE:
    "Texts.profile-investment-profile-accreditation-card-subtitle",
  PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_ALERT_MESSAGE:
    "Texts.profile-investment-profile-accreditation-card-alert-message",
  PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_ALERT_CTA:
    "Texts.profile-investment-profile-accreditation-card-alert-cta",
  PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_CTA_COMPLETE:
    "Texts.profile-investment-profile-accreditation-card-cta-complete",
  PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_CTA_VIEW:
    "Texts.profile-investment-profile-accreditation-card-cta-view",

  // Settings
  PROFILE_SETTINGS_EMAIL_CARD_TITLE: "Texts.profile-settings-email-card-title",
  PROFILE_SETTINGS_EMAIL_CARD_FOOTER:
    "Texts.profile-settings-email-card-footer",
  PROFILE_SETTINGS_EMAIL_CARD_FIELD_LABEL:
    "Texts.profile-settings-email-card-field-label",
  PROFILE_SETTINGS_PHONE_NUMBER_CARD_TITLE:
    "Texts.profile-settings-phone-number-card-title",
  PROFILE_SETTINGS_PHONE_NUMBER_CARD_FOOTER:
    "Texts.profile-settings-phone-number-card-footer",
  PROFILE_SETTINGS_PHONE_NUMBER_CARD_FIELD_LABEL:
    "Texts.profile-settings-phone-number-card-field-label",
  PROFILE_SETTINGS_SECURITY_CARD_TITLE:
    "Texts.profile-settings-security-card-title",
  PROFILE_SETTINGS_SECURITY_CARD_SUBTITLE:
    "Texts.profile-settings-security-card-subtitle",
  PROFILE_SETTINGS_SECURITY_CARD_FOOTER:
    "Texts.profile-settings-security-card-footer",
  PROFILE_SETTINGS_SECURITY_CARD_2FA_TITLE:
    "Texts.profile-settings-security-card-2fa-title",
  PROFILE_SETTINGS_SECURITY_CARD_2FA_SUBTITLE:
    "Texts.profile-settings-security-card-2fa-subtitle",
  PROFILE_SETTINGS_SECURITY_CARD_2FA_CTA:
    "Texts.profile-settings-security-card-2fa-cta",
  PROFILE_SETTINGS_SECURITY_CARD_2FA_DISABLE_CTA:
    "Texts.profile-settings-security-card-2fa-disable-cta",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_TITLE:
    "Texts.profile-settings-security-card-password-title",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_SUBTITLE:
    "Texts.profile-settings-security-card-password-subtitle",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_CTA:
    "Texts.profile-settings-security-card-password-cta",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_CTA_LOADING:
    "Texts.profile-settings-security-card-password-cta-loading",
  PROFILE_SETTINGS_SECURITY_CARD_CURRENT_PASSWORD_LABEL:
    "Texts.profile-settings-security-card-current-password-label",
  PROFILE_SETTINGS_SECURITY_CARD_NEW_PASSWORD_LABEL:
    "Texts.profile-settings-security-card-new-password-label",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_REQUIREMENTS_UPPERCASE:
    "Texts.profile-settings-security-card-password-requirements-uppercase",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_REQUIREMENTS_LOWERCASE:
    "Texts.profile-settings-security-card-password-requirements-lowercase",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_REQUIREMENTS_NUMBER:
    "Texts.profile-settings-security-card-password-requirements-number",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_REQUIREMENTS_LENGTH:
    "Texts.profile-settings-security-card-password-requirements-length",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_GENERAL_ERROR_MESSAGE:
    "Texts.profile-settings-security-card-password-general-error-message",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_REQUIREMENTS_NOT_MET_MESSAGE:
    "Texts.profile-settings-security-card-password-requirements-not-met-message",
  PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_REQUIRED_FIELD:
    "Texts.profile-settings-security-card-password-required-field",
  PROFILE_SETTINGS_SECURITY_CARD_2FA_ENABLED:
    "Texts.profile-settings-security-card-2fa-enabled",
  PROFILE_SETTINGS_SECURITY_CARD_2FA_REQUEST_DISABLE:
    "Texts.profile-settings-security-card-2fa-request-disable",

  PROFILE_SETTINGS_ACCOUNT_ID_CARD_TITLE:
    "Texts.profile-settings-account-id-card-title",
  PROFILE_SETTINGS_ACCOUNT_ID_CARD_SUBTITLE:
    "Texts.profile-settings-account-id-card-subtitle",
  PROFILE_SETTINGS_ACCOUNT_ID_COPIED:
    "Texts.profile-settings-account-id-copied",

  PROFILE_KEY_PARTIES_TITLE: "Texts.profile-key-parties-title",
  PROFILE_KEY_PARTIES_SUBTITLE: "Texts.profile-key-parties-subtitle",
  PROFILE_KEY_PARTIES_MEMBER_NAME_COLUMN:
    "Texts.profile-key-parties-member-name-column",
  PROFILE_KEY_PARTIES_NO_KEY_PARTIES:
    "Texts.profile-key-parties-no-key-parties",
  PROFILE_KEY_PARTIES_NO_KEY_PARTIES_DETAIL:
    "Texts.profile-key-parties-no-key-parties-detail",
  PROFILE_KEY_PARTIES_REQUIRED: "Texts.profile-key-parties-required",
  PROFILE_KEY_PARTIES_INCOMPLETE_ALERT:
    "Texts.profile-key-parties-incomplete-alert",
  PROFILE_KEY_PARTIES_NO_KEY_PARTIES_ADD_MEMBER:
    "Texts.profile-key-parties-no-key-parties-add-member",
  PROFILE_KEY_PARTIES_INDIVIDUAL: "Texts.profile-key-parties-individual",
  PROFILE_KEY_PARTIES_INDIVIDUAL_DETAIL:
    "Texts.profile-key-parties-individual-detail",
  PROFILE_KEY_PARTIES_ENTITY: "Texts.profile-key-parties-entity",
  PROFILE_KEY_PARTIES_ENTITY_DETAIL: "Texts.profile-key-parties-entity-detail",
  PROFILE_KEY_PARTIES_10_PERCENT_OWNERSHIP_COLUMN:
    "Texts.profile-key-parties-10-percent-ownership-column",
  PROFILE_KEY_PARTIES_25_PERCENT_OWNERSHIP_COLUMN:
    "Texts.profile-key-parties-25-percent-ownership-column",
  PROFILE_KEY_PARTIES_PERCENT_OWNERSHIP_COLUMN_TOOLTIP:
    "Texts.profile-key-parties-percent-ownership-column-tooltip",
  PROFILE_KEY_PARTIES_LEGAL_SIGNER_COLUMN:
    "Texts.profile-key-parties-legal-signer-column",
  PROFILE_KEY_PARTIES_LEGAL_SIGNER_COLUMN_TOOLTIP:
    "Texts.profile-key-parties-legal-signer-column-tooltip",
  PROFILE_KEY_PARTIES_INVITE_COLUMN: "Texts.profile-key-parties-invite-column",
  PROFILE_KEY_PARTIES_INVITE_COLUMN_TOOLTIP:
    "Texts.profile-key-parties-invite-column-tooltip",
  PROFILE_KEY_PARTIES_SAVE: "Texts.profile-key-parties-save",
  PROFILE_KEY_PARTIES_SAVE_NOTE: "Texts.profile-key-parties-save-note",
  PROFILE_KEY_PARTIES_READ_ONLY_UPDATE_FOOTER:
    "Texts.profile-key-parties-read-only-update-footer",
  PROFILE_KEY_PARTIES_CONTINUE: "Texts.profile-key-parties-continue",
  PROFILE_KEY_PARTIES_ADDITIONAL_DETAILS_TOOLTIP:
    "Texts.profile-key-parties-additional-details-tooltip",
  PROFILE_KEY_PARTIES_VALIDATION_EMAIL:
    "Texts.profile-key-parties-validation-email",
  PROFILE_KEY_PARTIES_ADDRESS_STREET:
    "Texts.profile-key-parties-address-street",
  PROFILE_KEY_PARTIES_ADDRESS_STREET_PLACEHOLDER:
    "Texts.profile-key-parties-address-street-placeholder",
  PROFILE_KEY_PARTIES_ADDRESS_ADDITIONAL_INFO:
    "Texts.profile-key-parties-address-additional-info",
  PROFILE_KEY_PARTIES_ADDRESS_CITY: "Texts.profile-key-parties-address-city",
  PROFILE_KEY_PARTIES_ADDRESS_CITY_PLACEHOLDER:
    "Texts.profile-key-parties-address-city-placeholder",
  PROFILE_KEY_PARTIES_ADDRESS_ZIP: "Texts.profile-key-parties-address-zip",
  PROFILE_KEY_PARTIES_ADDRESS_ZIP_PLACEHOLDER:
    "Texts.profile-key-parties-address-zip-placeholder",
  PROFILE_KEY_PARTIES_ADDRESS_STATE: "Texts.profile-key-parties-address-state",
  PROFILE_KEY_PARTIES_BIRTH_DATE_FORMAT:
    "Texts.profile-key-parties-birth-date-format",

  REQUIRED_KEY_PARTY_FUND_REVOCABLE_TRUST_BASIC:
    "Texts.required-key-party-revocable-trust-basic",
  REQUIRED_KEY_PARTY_FUND_IRREVOCABLE_TRUST_BASIC:
    "Texts.required-key-party-irrevocable-trust-basic",
  REQUIRED_KEY_PARTY_FUND_LIMITED_GENERAL_PARTNERSHIP_BASIC:
    "Texts.required-key-party-limited-partnership/general-partnership-basic",
  REQUIRED_KEY_PARTY_FUND_JOINT_ACCOUNT_BASIC:
    "Texts.required-key-party-joint-account-basic",
  REQUIRED_KEY_PARTY_FUND_NON_PROFIT_FOUNDATION_BASIC:
    "Texts.required-key-party-non-profit-foundation-basic",
  REQUIRED_KEY_PARTY_FUND_FOR_PROFIT_FOUNDATION_BASIC:
    "Texts.required-key-party-for-profit-foundation-basic",
  REQUIRED_KEY_PARTY_FUND_FUND_BASIC: "Texts.required-key-party-fund-basic",
  REQUIRED_KEY_PARTY_FUND_LLC_BASIC: "Texts.required-key-party-llc-basic",
  REQUIRED_KEY_PARTY_FUND_CORPORATION_BASIC:
    "Texts.required-key-party-corporation-basic",
  REQUIRED_KEY_PARTY_FUND_OTHER_BASIC: "Texts.required-key-party-other-basic",

  REQUIRED_KEY_PARTY_FUND_REVOCABLE_TRUST_ENHANCED:
    "Texts.required-key-party-revocable-trust-enhanced",
  REQUIRED_KEY_PARTY_FUND_IRREVOCABLE_TRUST_ENHANCED:
    "Texts.required-key-party-irrevocable-trust-enhanced",
  REQUIRED_KEY_PARTY_FUND_LIMITED_GENERAL_PARTNERSHIP_ENHANCED:
    "Texts.required-key-party-limited-partnership/general-partnership-enhanced",
  REQUIRED_KEY_PARTY_FUND_JOINT_ACCOUNT_ENHANCED:
    "Texts.required-key-party-joint-account-enhanced",
  REQUIRED_KEY_PARTY_FUND_NON_PROFIT_FOUNDATION_ENHANCED:
    "Texts.required-key-party-non-profit-foundation-enhanced",
  REQUIRED_KEY_PARTY_FUND_FOR_PROFIT_FOUNDATION_ENHANCED:
    "Texts.required-key-party-for-profit-foundation-enhanced",
  REQUIRED_KEY_PARTY_FUND_FUND_ENHANCED:
    "Texts.required-key-party-fund-enhanced",
  REQUIRED_KEY_PARTY_FUND_LLC_ENHANCED: "Texts.required-key-party-llc-enhanced",
  REQUIRED_KEY_PARTY_FUND_CORPORATION_ENHANCED:
    "Texts.required-key-party-corporation-enhanced",
  REQUIRED_KEY_PARTY_FUND_OTHER_ENHANCED:
    "Texts.required-key-party-other-enhanced",

  PROFILE_KEY_PARTIES_UPDATE_SUCCESS:
    "Texts.profile-key-parties-update-success",
  PROFILE_KEY_PARTIES_COMPLETE_DETAILS_TITLE:
    "Texts.profile-key-parties-complete-details-title",
  PROFILE_KEY_PARTIES_COMPLETE_DETAILS_SUBTITLE:
    "Texts.profile-key-parties-complete-details-subtitle",
  PROFILE_KEY_PARTIES_TAX_INFO_TITLE:
    "Texts.profile-key-parties-tax-info-title",
  PROFILE_KEY_PARTIES_TAX_RESIDENCE_COUNTRY:
    "Texts.profile-key-parties-tax-residence-country",
  PROFILE_KEY_PARTIES_SSN: "Texts.profile-key-parties-ssn",
  PROFILE_KEY_PARTIES_TAX_ID: "Texts.profile-key-parties-tax-id",
  PROFILE_KEY_PARTIES_TAX_NOT_REQUIRED:
    "Texts.profile-key-parties-tax-not-required",
  PROFILE_KEY_PARTIES_TAX_PURPOSE_INFO:
    "Texts.profile-key-parties-tax-purpose-info",
  PROFILE_KEY_PARTIES_RESIDENTIAL_ADDRESS_TITLE:
    "Texts.profile-key-parties-residential-address-title",
  PROFILE_KEY_PARTIES_RESIDENTIAL_ADDRESS_SUBTITLE:
    "Texts.profile-key-parties-residential-address-subtitle",
  PROFILE_KEY_PARTIES_ID_DOCUMENT_TITLE:
    "Texts.profile-key-parties-id-document-title",
  PROFILE_KEY_PARTIES_ID_DOCUMENT_SUBTITLE:
    "Texts.profile-key-parties-id-document-subtitle",
  PROFILE_KEY_PARTIES_PASSPORT_ONLY_NOTICE:
    "Texts.profile-key-parties-passport-only-notice",
  PROFILE_KEY_PARTIES_PASSPORT: "Texts.profile-key-parties-passport",
  PROFILE_KEY_PARTIES_DRIVERS_LICENSE:
    "Texts.profile-key-parties-drivers-license",
  PROFILE_KEY_PARTIES_PASSPORT_INFO: "Texts.profile-key-parties-passport-info",
  PROFILE_KEY_PARTIES_LICENSE_INFO: "Texts.profile-key-parties-license-info",
  PROFILE_KEY_PARTIES_PASSPORT_UPLOAD_INSTRUCTIONS:
    "Texts.profile-key-parties-passport-upload-instructions",
  PROFILE_KEY_PARTIES_DRIVERS_LICENSE_UPLOAD_INSTRUCTIONS:
    "Texts.profile-key-parties-license-upload-instructions",
  PROFILE_KEY_PARTIES_VIEW_SAMPLE: "Texts.profile-key-parties-view-sample",
  PROFILE_KEY_PARTIES_DRIVERS_LICENSE_FRONT_SAMPLE_UPLOADS:
    "Texts.profile-key-parties-license-front-sample-uploads",
  PROFILE_KEY_PARTIES_DRIVERS_LICENSE_BACK_SAMPLE_UPLOADS:
    "Texts.profile-key-parties-license-back-sample-uploads",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD:
    "Texts.profile-key-parties-sample-good-upload",
  PROFILE_KEY_PARTIES_SAMPLE_BAD_UPLOAD:
    "Texts.profile-key-parties-sample-bad-upload",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD_FORMATS:
    "Texts.profile-key-parties-sample-good-upload-formats",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD_DRIVERS_LICENSE_FRONT_READABLE:
    "Texts.profile-key-parties-sample-good-upload-drivers-license-front-readable",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD_DRIVERS_LICENSE_FRONT_CONTENTS:
    "Texts.profile-key-parties-sample-good-upload-drivers-license-front-contents",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD_DRIVERS_LICENSE_BACK_READABLE:
    "Texts.profile-key-parties-sample-good-upload-drivers-license-back-readable",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD_DRIVERS_LICENSE_BACK_CONTENTS:
    "Texts.profile-key-parties-sample-good-upload-drivers-license-back-contents",
  PROFILE_KEY_PARTIES_SAMPLE_BAD_UPLOAD_QUALITY:
    "Texts.profile-key-parties-sample-bad-upload-quality",
  PROFILE_KEY_PARTIES_SAMPLE_BAD_UPLOAD_CROPPED:
    "Texts.profile-key-parties-sample-bad-upload-cropped",
  PROFILE_KEY_PARTIES_SAMPLE_BAD_UPLOAD_COMBINED:
    "Texts.profile-key-parties-sample-bad-upload-combined",
  PROFILE_KEY_PARTIES_PASSPORT_SAMPLE_UPLOADS:
    "Texts.profile-key-parties-passport-sample-uploads",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD_PASSPORT_READABLE:
    "Texts.profile-key-parties-sample-good-upload-passport-readable",
  PROFILE_KEY_PARTIES_SAMPLE_GOOD_UPLOAD_PASSPORT_CONTENTS:
    "Texts.profile-key-parties-sample-good-upload-passport-contents",
  PROFILE_KEY_PARTIES_SAMPLE_DRIVER_LICENSE_FRONT_UPLOAD_FOOTER:
    "Texts.profile-key-parties-sample-driver-license-front-upload-footer",
  PROFILE_KEY_PARTIES_SAMPLE_DRIVER_LICENSE_BACK_UPLOAD_FOOTER:
    "Texts.profile-key-parties-sample-driver-license-back-upload-footer",
  PROFILE_KEY_PARTIES_SAMPLE_PASSPORT_UPLOAD_FOOTER:
    "Texts.profile-key-parties-sample-passport-upload-footer",
  PROFILE_KEY_PARTIES_SAMPLE_CLOSE: "Texts.profile-key-parties-sample-close",
  PROFILE_KEY_PARTIES_VIEW_DETAILS: "Texts.profile-key-parties-view-details",
  PROFILE_KEY_PARTIES_COMPLETE_DETAILS:
    "Texts.profile-key-parties-complete-details",
  PROFILE_KEY_PARTIES_VIEW_DETAILS_SUBTITLE:
    "Texts.profile-key-parties-view-details-subtitle",
  PROFILE_KEY_PARTIES_COMPLETE_DETAILS_MENU_SUBTITLE:
    "Texts.profile-key-parties-complete-details-menu-subtitle",
  PROFILE_KEY_PARTIES_VIEW_MEMBER_INFO:
    "Texts.profile-key-parties-view-member-info",
  PROFILE_KEY_PARTIES_VIEW_MEMBER_INFO_DETAILS:
    "Texts.profile-key-parties-view-member-info-details",
  PROFILE_KEY_PARTIES_VIEW_MEMBER_REMOVE:
    "Texts.profile-key-parties-view-member-remove",
  PROFILE_KEY_PARTIES_VIEW_MEMBER_REMOVE_DETAILS:
    "Texts.profile-key-parties-view-member-remove-details",
  PROFILE_KEY_PARTIES_BIRTH_DATE_AGE_ERROR:
    "Texts.profile-key-parties-birth-date-age-error",
  PROFILE_KEY_PARTIES_RESOLVE_UPDATE:
    "Texts.profile-key-parties-resolve-update",

  DOWNLOAD_DATA_SECURITY_CARD_TITLE: "Texts.download-data-security-card-title",
  DOWNLOAD_DATA_SECURITY_CARD_SUBTITLE:
    "Texts.download-data-security-card-subtitle",
  DOWNLOAD_DATA_SECURITY_CARD_TOOLTIP:
    "Texts.download-data-security-card-tooltip",
  DOWNLOAD_DATA_SECURITY_CARD_CTA: "Texts.download-data-security-card-cta",
  DOWNLOAD_DATA_SECURITY_CARD_SUCCESS:
    "Texts.download-data-security-card-success",
  DOWNLOAD_DATA_SECURITY_CARD_ERROR: "Texts.download-data-security-card-error",
  DOWNLOAD_DATA_SECURITY_CARD_TRY_AGAIN:
    "Texts.download-data-security-card-try-again",

  DOWNLOAD_DATA_POPUP_TITLE: "Texts.download-data-popup-title",
  DOWNLOAD_DATA_POPUP_BODY: "Texts.download-data-popup-body",
  DOWNLOAD_DATA_POPUP_BUTTON: "Texts.download-data-popup-button",
  DOWNLOAD_DATA_POPUP_BUTTON_LOADING:
    "Texts.download-data-popup-button-loading",
  DOWNLOAD_DATA_POPUP_CANCEL: "Texts.download-data-popup-cancel",
  DOWNLOAD_DATA_POPUP_SUCCESS: "Texts.download-data-popup-success",
  DOWNLOAD_DATA_POPUP_ERROR: "Texts.download-data-popup-error",

  // Key Parties Dialog
  PROFILE_KEY_PARTIES_ADD_INDIVIDUAL_TITLE:
    "Texts.profile-key-parties-add-individual-title",
  PROFILE_KEY_PARTIES_ADD_INDIVIDUAL_DESCRIPTION:
    "Texts.profile-key-parties-add-individual-description",
  PROFILE_KEY_PARTIES_PERSONAL_INFORMATION_TITLE:
    "Texts.profile-key-parties-personal-information-title",
  PROFILE_KEY_PARTIES_PERSONAL_INFORMATION_DESCRIPTION:
    "Texts.profile-key-parties-personal-information-description",
  PROFILE_KEY_PARTIES_NOT_APPLICABLE:
    "Texts.profile-key-parties-not-applicable",
  PROFILE_KEY_PARTIES_PERCENT_OWNERSHIP_COLUMN_ENTITY_TOOLTIP:
    "Texts.profile-key-parties-percent-ownership-column-entity-tooltip",
  PROFILE_KEY_PARTIES_VALIDATION_ERROR:
    "Texts.profile-key-parties-validation-error",
  PROFILE_KEY_PARTIES_FIRST_NAME_LABEL:
    "Texts.profile-key-parties-first-name-label",
  PROFILE_KEY_PARTIES_MIDDLE_NAME_LABEL:
    "Texts.profile-key-parties-middle-name-label",
  PROFILE_KEY_PARTIES_LAST_NAME_LABEL:
    "Texts.profile-key-parties-last-name-label",
  PROFILE_KEY_PARTIES_EMAIL_LABEL: "Texts.profile-key-parties-email-label",
  PROFILE_KEY_PARTIES_RELATIONSHIP_TITLE:
    "Texts.profile-key-parties-relationship-title",
  PROFILE_KEY_PARTIES_RELATIONSHIP_DESCRIPTION:
    "Texts.profile-key-parties-relationship-description",
  PROFILE_KEY_PARTIES_10_PERCENT_UBO_LABEL:
    "Texts.profile-key-parties-10-percent-ubo-label",
  PROFILE_KEY_PARTIES_10_PERCENT_UBO_DESCRIPTION:
    "Texts.profile-key-parties-10-percent-ubo-description",
  PROFILE_KEY_PARTIES_25_PERCENT_UBO_LABEL:
    "Texts.profile-key-parties-25-percent-ubo-label",
  PROFILE_KEY_PARTIES_25_PERCENT_UBO_DESCRIPTION:
    "Texts.profile-key-parties-25-percent-ubo-description",
  PROFILE_KEY_PARTIES_LEGAL_SIGNER_LABEL:
    "Texts.profile-key-parties-legal-signer-label",
  PROFILE_KEY_PARTIES_LEGAL_SIGNER_DESCRIPTION:
    "Texts.profile-key-parties-legal-signer-description",
  PROFILE_KEY_PARTIES_CANCEL: "Texts.profile-key-parties-cancel",
  PROFILE_KEY_PARTIES_UPDATE_INDIVIDUAL_TITLE:
    "Texts.profile-key-parties-update-individual-title",
  PROFILE_KEY_PARTIES_UPDATE_INDIVIDUAL_SUBMIT:
    "Texts.profile-key-parties-update-individual-submit",
  PROFILE_KEY_PARTIES_UPDATE_INDIVIDUAL_SUBMIT_IN_PROGRESS:
    "Texts.profile-key-parties-update-individual-submit-in-progress",
  PROFILE_KEY_PARTIES_UPDATE_INDIVIDUAL_SUCCESS_MESSAGE:
    "Texts.profile-key-parties-update-individual-success-message",
  PROFILE_KEY_PARTIES_ADD_INDIVIDUAL_SUBMIT:
    "Texts.profile-key-parties-add-individual-submit",
  PROFILE_KEY_PARTIES_ADD_INDIVIDUAL_SUBMIT_IN_PROGRESS:
    "Texts.profile-key-parties-add-individual-submit-in-progress",
  PROFILE_KEY_PARTIES_ADD_INDIVIDUAL_SUCCESS_MESSAGE:
    "Texts.profile-key-parties-add-individual-success-message",
  PROFILE_KEY_PARTIES_ADD_ENTITY_SUBMIT:
    "Texts.profile-key-parties-add-entity-submit",
  PROFILE_KEY_PARTIES_ADD_ENTITY_SUBMIT_IN_PROGRESS:
    "Texts.profile-key-parties-add-entity-submit-in-progress",
  PROFILE_KEY_PARTIES_ADD_ENTITY_SUCCESS_MESSAGE:
    "Texts.profile-key-parties-add-entity-success-message",
  PROFILE_KEY_PARTIES_ADD_ENTITY_SUCCESS_COMPLETE_DETAILS_BUTTON:
    "Texts.profile-key-parties-add-entity-success-complete-details-button",
  PROFILE_KEY_PARTIES_UPDATE_ENTITY_TITLE:
    "Texts.profile-key-parties-update-entity-title",
  PROFILE_KEY_PARTIES_UPDATE_ENTITY_SUBMIT:
    "Texts.profile-key-parties-update-entity-submit",
  PROFILE_KEY_PARTIES_UPDATE_ENTITY_SUBMIT_IN_PROGRESS:
    "Texts.profile-key-parties-update-entity-submit-in-progress",
  PROFILE_KEY_PARTIES_UPDATE_ENTITY_SUCCESS_MESSAGE:
    "Texts.profile-key-parties-update-entity-success-message",
  PROFILE_KEY_PARTIES_ADD_INDIVIDUAL_SUCCESS_COMPLETE_DETAILS_BUTTON:
    "Texts.profile-key-parties-add-individual-success-complete-details-button",
  PROFILE_KEY_PARTIES_ADD_ENTITY_TITLE:
    "Texts.profile-key-parties-add-entity-title",
  PROFILE_KEY_PARTIES_ADD_ENTITY_SUBTITLE:
    "Texts.profile-key-parties-add-entity-subtitle",
  PROFILE_KEY_PARTIES_ENTITY_INFORMATION:
    "Texts.profile-key-parties-entity-information",
  PROFILE_KEY_PARTIES_ENTITY_INFORMATION_SUBTITLE:
    "Texts.profile-key-parties-entity-information-subtitle",

  PROFILE_KEY_PARTIES_BUSINESS_INFORMATION:
    "Texts.profile-key-parties-business-information",
  PROFILE_KEY_PARTIES_BUSINESS_INFORMATION_SUBTITLE:
    "Texts.profile-key-parties-business-information-subtitle",
  PROFILE_KEY_PARTIES_ENTITY_CONTACT_EMAIL:
    "Texts.profile-key-parties-entity-contact-email",
  PROFILE_KEY_PARTIES_DOING_BUSINESS_AS:
    "Texts.profile-key-parties-doing-business-as",
  PROFILE_KEY_PARTIES_LEGAL_DOCUMENTS:
    "Texts.profile-key-parties-legal-documents",
  PROFILE_KEY_PARTIES_LEGAL_DOCUMENTS_SUBTITLE:
    "Texts.profile-key-parties-legal-documents-subtitle",

  PROFILE_KEY_PARTIES_DELETE_CONFIRMATION_TITLE:
    "Texts.profile-key-parties-delete-confirmation-title",
  PROFILE_KEY_PARTIES_DELETE_CONFIRMATION_SUBTITLE:
    "Texts.profile-key-parties-delete-confirmation-subtitle",
  PROFILE_KEY_PARTIES_DELETE_CONFIRMATION_CANCEL:
    "Texts.profile-key-parties-delete-confirmation-cancel",
  PROFILE_KEY_PARTIES_DELETE_CONFIRMATION_DELETE:
    "Texts.profile-key-parties-delete-confirmation-delete",
  PROFILE_KEY_PARTIES_DELETE_SUCCESS_MESSAGE:
    "Texts.profile-key-parties-delete-success-message",
  PROFILE_KEY_PARTIES_DELETE_CONFIRMATION_DELETING:
    "Texts.profile-key-parties-delete-confirmation-deleting",

  DELETE_SECURITY_CARD_TITLE: "Texts.delete-security-card-title",
  DELETE_SECURITY_CARD_TITLE_ENTITY: "Texts.delete-security-card-title-entity",
  DELETE_SECURITY_CARD_TITLE_INDIVIDUAL:
    "Texts.delete-security-card-title-individual",
  DELETE_SECURITY_CARD_TITLE_INDIVIDUAL_NO_NAME:
    "Texts.delete-security-card-title-individual-no-name",
  DELETE_SECURITY_CARD_SUBTITLE: "Texts.delete-security-card-subtitle",
  DELETE_SECURITY_CARD_CTA_TOOLTIP: "Texts.delete-security-card-cta-tooltip",
  DELETE_SECURITY_CARD_SUBTITLE_ENTITY:
    "Texts.delete-security-card-subtitle-entity",
  DELETE_SECURITY_CARD_SUBTITLE_INDIVIDUAL:
    "Texts.delete-security-card-subtitle-individual",
  DELETE_SECURITY_CARD_SUBTITLE_PENDING_DELETION:
    "Texts.delete-security-card-subtitle-pending-deletion",

  DELETE_SECURITY_CARD_CTA: "Texts.delete-security-card-cta",
  DELETE_SECURITY_CARD_SUCCESS: "Texts.delete-security-card-success",
  DELETE_SECURITY_CARD_REMOVE_ACCESS_SUCCESS:
    "Texts.delete-security-card-remove-access-success",
  DELETE_SECURITY_CARD_TRY_AGAIN: "Texts.delete-security-card-try-again",
  DELETE_SECURITY_CARD_PENDING_VERIFICATION_SUBTITLE:
    "Texts.delete-security-card-pending-verification-subtitle",
  DELETE_SECURITY_CARD_CONFIRM_TITLE:
    "Texts.delete-security-card-confirm-title",
  DELETE_SECURITY_CARD_CONFIRM_SUBTITLE:
    "Texts.delete-security-card-confirm-subtitle",
  DELETE_SECURITY_CARD_CONFIRM_CTA: "Texts.delete-security-card-confirm-cta",
  DELETE_SECURITY_CARD_CONFIRM_CTA_PENDING:
    "Texts.delete-security-card-confirm-cta-pending",
  DELETE_SECURITY_CARD_CONFIRM_CANCEL:
    "Texts.delete-security-card-confirm-cancel",
  DELETE_SECURITY_CARD_CONFIRM_SUBTITLE_PENDING:
    "Texts.delete-security-card-confirm-subtitle-pending",

  DELETE_SECURITY_CARD_REMOVE_ACCESS_TITLE:
    "Texts.delete-security-card-remove-access-title",
  DELETE_SECURITY_CARD_REMOVE_ACCESS_SUBTITLE:
    "Texts.delete-security-card-remove-access-subtitle",
  DELETE_SECURITY_CARD_REMOVE_ACCESS_CTA:
    "Texts.delete-security-card-remove-access-cta",
  DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_TITLE:
    "Texts.delete-security-card-remove-access-confirm-title",
  DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_SUBTITLE:
    "Texts.delete-security-card-remove-access-confirm-subtitle",
  DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_CTA:
    "Texts.delete-security-card-remove-access-confirm-cta",
  DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_CTA_PENDING:
    "Texts.delete-security-card-remove-access-confirm-cta-pending",

  PROFILE_SETTINGS_LANGUAGE_CARD_TITLE:
    "Texts.profile-settings-language-card-title",
  PROFILE_SETTINGS_LANGUAGE_CARD_SUBTITLE:
    "Texts.profile-settings-language-card-subtitle",

  PROFILE_SETTINGS_DEVICES_CARD_TITLE:
    "Texts.profile-settings-devices-card-title",
  PROFILE_SETTINGS_DEVICES_CARD_SUBTITLE:
    "Texts.profile-settings-devices-card-subtitle",
  PROFILE_SETTINGS_DEVICES_CARD_ACTIVE_SESSION:
    "Texts.profile-settings-devices-card-active-session",
  PROFILE_SETTINGS_DEVICES_CARD_LAST_ACCESS:
    "Texts.profile-settings-devices-card-last-access",
  PROFILE_SETTINGS_DEVICES_CARD_LOGGING_OUT_CTA:
    "Texts.profile-settings-devices-card-logging-out-cta",
  PROFILE_SETTINGS_DEVICES_CARD_LOG_OUT_CTA:
    "Texts.profile-settings-devices-card-log-out-cta",
  PROFILE_SETTINGS_DEVICES_CARD_THIS_DEVICE:
    "Texts.profile-settings-devices-card-this-device",

  LOGOUT: "Texts.logout",
  ERROR_HAS_OCCURRED: "Texts.error-has-occurred",
  ERROR_COPY: "Texts.error-copy",
  AUTOCOMPLETE_CLEAR: "Texts.autocomplete-clear",
  AUTOCOMPLETE_OPEN: "Texts.autocomplete-open",
  AUTOCOMPLETE_CLOSE: "Texts.autocomplete-close",

  PORTFOLIO_TITLE: "Texts.portfolio-title",
  PORTFOLIO_VALUE: "Texts.portfolio-value",
  PORTFOLIO_PERFORMANCE_TIME: "Texts.portfolio-performance-time",
  PORTFOLIO_TOOLTIP_TEXT: "Texts.portfolio-tooltip-text",
  PORTFOLIO_ERROR: "Texts.portfolio-error",
  PORTFOLIO_ERROR_INVESTMENTS: "Texts.portfolio-error-investments",

  PORTFOLIO_ASSETS_MY_ASSETS: "Texts.portfolio-assets-my-assets",
  PORTFOLIO_ASSETS_IN_PROGRESS: "Texts.portfolio-assets-in-progress",
  PORTFOLIO_ASSETS_PREVIOUSLY_OWNED: "Texts.portfolio-assets-previously-owned",

  PORTFOLIO_MY_ASSETS_PENDING_ISSUANCE:
    "Texts.portfolio-my-assets-pending-issuance",
  PORTFOLIO_MY_ASSETS_PENDING_ISSUANCE_TOOLTIP_REGULAR:
    "Texts.portfolio-my-assets-pending-issuance-tooltip-regular",
  PORTFOLIO_MY_ASSETS_PENDING_ISSUANCE_TOOLTIP_TWO_TOKEN:
    "Texts.portfolio-my-assets-pending-issuance-tooltip-two-token",
  PORTFOLIO_MY_ASSETS_ASSET_UNITS: "Texts.portfolio-my-assets-asset-units",
  PORTFOLIO_MY_ASSETS_ASSET_PRICE: "Texts.portfolio-my-assets-asset-price",
  PORTFOLIO_MY_ASSETS_ASSET_TOTAL_VALUE:
    "Texts.portfolio-my-assets-asset-total-value",
  PORTFOLIO_MY_ASSETS_LAST_90_DAYS: "Texts.portfolio-my-assets-last-90-days",
  PORTFOLIO_MY_ASSETS_ASSET_INVEST_MORE_CTA:
    "Texts.portfolio-my-assets-asset-invest-more-cta",
  PORTFOLIO_MY_ASSETS_ASSET_INVEST_CTA: "Texts.portfolio-my-assets-invest-cta",
  PORTFOLIO_MY_ASSETS_ASSET_TRADE_CTA:
    "Texts.portfolio-my-assets-asset-trade-cta",
  PORTFOLIO_MY_ASSETS_ASSET_SUBSCRIPTION:
    "Texts.portfolio-my-assets-asset-subscription",
  PORTFOLIO_MY_ASSETS_ASSET_VALUE: "Texts.portfolio-my-assets-asset-value",

  PORTFOLIO_MY_ASSETS_EMPTY_STATE_TITLE:
    "Texts.portfolio-my-assets-empty-state-title",
  PORTFOLIO_MY_ASSETS_EMPTY_STATE_GATED_DESCRIPTION:
    "Texts.portfolio-my-assets-empty-state-gated-description",
  PORTFOLIO_MY_ASSETS_EMPTY_STATE_PRIMARY_MARKET_TITLE:
    "Texts.portfolio-my-assets-empty-state-primary-market-title",
  PORTFOLIO_MY_ASSETS_EMPTY_STATE_PRIMARY_MARKET_DESCRIPTION:
    "Texts.portfolio-my-assets-empty-state-primary-market-description",
  PORTFOLIO_MY_ASSETS_EMPTY_STATE_PRIMARY_MARKET_CTA:
    "Texts.portfolio-my-assets-empty-state-primary-market-cta",
  PORTFOLIO_MY_ASSETS_EMPTY_STATE_SECONDARY_MARKET_TITLE:
    "Texts.portfolio-my-assets-empty-state-secondary-market-title",
  PORTFOLIO_MY_ASSETS_EMPTY_STATE_SECONDARY_MARKET_DESCRIPTION:
    "Texts.portfolio-my-assets-empty-state-secondary-market-description",
  PORTFOLIO_MY_ASSETS_EMPTY_STATE_SECONDARY_MARKET_CTA:
    "Texts.portfolio-my-assets-empty-state-secondary-market-cta",

  PORTFOLIO_IN_PROGRESS_EMPTY_STATE_TITLE:
    "Texts.portfolio-in-progress-empty-state-title",
  PORTFOLIO_IN_PROGRESS_EMPTY_STATE_DESCRIPTION:
    "Texts.portfolio-in-progress-empty-state-description",
  PORTFOLIO_IN_PROGRESS_EMPTY_STATE_CTA:
    "Texts.portfolio-in-progress-empty-state-cta",

  PORTFOLIO_IN_PROGESS_PLEDGED: "Texts.portfolio-in-progress-pledged",
  PORTFOLIO_IN_PROGESS_FUNDED: "Texts.portfolio-in-progress-funded",
  PORTFOLIO_IN_PROGESS_COMPLETE_CTA: "Texts.portfolio-in-progress-complete-cta",
  PORTFOLIO_IN_PROGESS_VIEW_INVESTMENT:
    "Texts.portfolio-in-progress-view-investment",
  PORTFOLIO_IN_PROGESS_DELETE_INVESTMENT:
    "Texts.portfolio-in-progress-delete-investment",
  PORTFOLIO_IN_PROGESS_DELETE_INVESTMENT_BUTTON_DISCLAIMER:
    "Texts.portfolio-in-progress-delete-investment-button-disclaimer",
  PORTFOLIO_IN_PROGESS_DELETE_INVESTMENT_BUTTON_CANCEL:
    "Texts.portfolio-in-progress-delete-investment-button-cancel",
  PORTFOLIO_IN_PROGESS_DELETE_INVESTMENT_BUTTON_PENDING:
    "Texts.portfolio-in-progress-delete-investment-button-pending",
  PORTFOLIO_IN_PROGESS_DELETE_INVESTMENT_BUTTON:
    "Texts.portfolio-in-progress-delete-investment-button",
  PORTFOLIO_IN_PROGESS_DELETE_INVESTMENT_SUCCESS:
    "Texts.portfolio-in-progress-delete-investment-success",
  PORTFOLIO_IN_PROGESS_DELETE_INVESTMENT_ERROR:
    "Texts.portfolio-in-progress-delete-investment-error",

  CASH_BALANCE_CARD_TITLE: "Texts.cash-balance-card-title",
  CASH_BALANCE_CARD_CTA: "Texts.cash-balance-card-cta",
  CASH_BALANCE_CARD_PROCESSING: "Texts.cash-balance-processing",
  CASH_BALANCE_CARD_PROCESSING_ENTITY:
    "Texts.cash-balance-card-processing-entity",
  CASH_BALANCE_CARD_DESCRIPTION: "Texts.cash-balance-card-description",

  ONBOARDING_CARD_TITLE: "Texts.onboarding-card-title",
  ONBOARDING_CARD_TITLE_UPDATES_REQUIRED:
    "Texts.onboarding-card-title-updates-required",

  ONBOARDING_CARD_SUBTITLE: "Texts.onboarding-card-subtitle",
  ONBOARDING_CARD_SUBTITLE_UPDATES_REQUIRED:
    "Texts.onboarding-card-subtitle-updates-required",

  ONBOARDING_CARD_ENTITY_INFORMATION_TITLE:
    "Texts.onboarding-card-entity-information-title",
  ONBOARDING_CARD_ENTITY_INFORMATION_SUBTITLE:
    "Texts.onboarding-card-entity-information-subtitle",
  ONBOARDING_CARD_ENTITY_INFORMATION_SUBTITLE_UPDATES_REQUIRED:
    "Texts.onboarding-card-entity-information-subtitle-updates-required",
  ONBOARDING_CARD_ENTITY_DOCUMENTS_TITLE:
    "Texts.onboarding-card-entity-documents-title",
  ONBOARDING_CARD_ENTITY_DOCUMENTS_SUBTITLE:
    "Texts.onboarding-card-entity-documents-subtitle",
  ONBOARDING_CARD_ENTITY_DOCUMENTS_SUBTITLE_UPDATES_REQUIRED:
    "Texts.onboarding-card-entity-documents-subtitle-updates-required",
  ONBOARDING_CARD_KEY_PARTIES_TITLE: "Texts.onboarding-card-key-parties-title",
  ONBOARDING_CARD_KEY_PARTIES_SUBTITLE:
    "Texts.onboarding-card-key-parties-subtitle",
  ONBOARDING_CARD_KEY_PARTIES_SUBTITLE_UPDATES_REQUIRED:
    "Texts.onboarding-card-key-parties-subtitle-updates-required",
  ONBOARDING_CARD_ENTITY_INFORMATION_UPDATES_REQUIRED_COUNT:
    "Texts.onboarding-card-entity-information-updates-required-count",
  ONBOARDING_CARD_ENTITY_DOCUMENTS_UPDATES_REQUIRED_COUNT:
    "Texts.onboarding-card-entity-documents-updates-required-count",
  ONBOARDING_CARD_KEY_PARTIES_UPDATES_REQUIRED_COUNT:
    "Texts.onboarding-card-key-parties-updates-required-count",
  ONBOARDING_CARD_KEY_PARTIES_UPDATES_REQUIRED_AND:
    "Texts.onboarding-card-key-parties-updates-required-and",
  ONBOARDING_CARD_KEY_PARTIES_UPDATES_REQUIRED_ADDITIONAL_INFO_LABEL:
    "Texts.onboarding-card-key-parties-updates-required-additional-info-label",
  ONBOARDING_CARD_UPDATES_REQUIRED_NEED_UPDATES_LABEL:
    "Texts.onboarding-card-updates-required-need-updates-label",
  ONBOARDING_CARD_MANAGE_BUTTON: "Texts.onboarding-card-manage-button",
  ONBOARDING_CARD_REVIEW_BUTTON: "Texts.onboarding-card-review-button",
  ONBOARDING_CARD_SUBMIT_BUTTON: "Texts.onboarding-card-submit-button",
  ONBOARDING_IN_REVIEW_TITLE: "Texts.onboarding-in-review-title",
  ONBOARDING_IN_REVIEW_COPY_NIE: "Texts.onboarding-in-review-copy-nie",
  ONBOARDING_IN_REVIEW_COPY_REGULAR: "Texts.onboarding-in-review-copy-regular",
  ONBOARDING_IN_REVIEW_BACK_TO_ISSUER:
    "Texts.onboarding-in-review-back-to-issuer",
  ONBOARDING_IN_REVIEW_EXPLORE_OFFERINGS:
    "Texts.onboarding-in-review-explore-offerings",
  ONBOARDING_CARD_MODAL_TITLE: "Texts.onboarding-card-modal-title",
  ONBOARDING_CARD_MODAL_SUBTITLE: "Texts.onboarding-card-modal-subtitle",
  ONBOARDING_CARD_MODAL_CANCEL_BUTTON:
    "Texts.onboarding-card-modal-cancel-button",
  ONBOARDING_CARD_MODAL_SUBMIT_BUTTON:
    "Texts.onboarding-card-modal-submit-button",
  ONBOARDING_CARD_MODAL_SUBMIT_BUTTON_LOADING:
    "Texts.onboarding-card-modal-submit-button-loading",
  ONBOARDING_CARD_CONFIRMATION_MODAL_TITLE:
    "Texts.onboarding-card-confirmation-modal-title",
  ONBOARDING_CARD_CONFIRMATION_MODAL_DESCRIPTION:
    "Texts.onboarding-card-confirmation-modal-description",
  ONBOARDING_CARD_CONFIRMATION_MODAL_WARNING_1:
    "Texts.onboarding-card-confirmation-modal-warning-1",
  ONBOARDING_CARD_CONFIRMATION_MODAL_WARNING_2:
    "Texts.onboarding-card-confirmation-modal-warning-2",
  ONBOARDING_CARD_CONFIRMATION_MODAL_EMAILED_ADDITIONAL_INFO_CHECKBOX:
    "Texts.onboarding-card-confirmation-modal-emailed-additional-info-checkbox",
  ONBOARDING_CARD_CONFIRMATION_MODAL_CANCEL_BUTTON:
    "Texts.onboarding-card-confirmation-modal-cancel-button",
  ONBOARDING_CARD_CONFIRMATION_MODAL_SUBMIT_BUTTON:
    "Texts.onboarding-card-confirmation-modal-submit-button",
  ONBOARDING_CARD_CONFIRMATION_MODAL_SUBMIT_BUTTON_LOADING:
    "Texts.onboarding-card-confirmation-modal-submit-button-loading",
  ONBOARDING_CARD_STATUS_LABEL_COMPLETED:
    "Texts.onboarding-card-status-label-completed",
  ONBOARDING_CARD_STATUS_LABEL_IN_PROGRESS:
    "Texts.onboarding-card-status-label-in-progress",
  ONBOARDING_CARD_STATUS_LABEL_UPDATES_REQUIRED:
    "Texts.onboarding-card-status-label-updates-required",
  ONBOARDING_CARD_STATUS_LABEL_NOT_COMPLETED:
    "Texts.onboarding-card-status-label-not-completed",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_TITLE:
    "Texts.onboarding-card-updates-required-section-title",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_SUBTITLE:
    "Texts.onboarding-card-updates-required-section-subtitle",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_BUTTON:
    "Texts.onboarding-card-updates-required-section-button",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_BUTTON_PROFILE_SUBMIT:
    "Texts.onboarding-card-updates-required-section-button-profile-submit",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_DOCUMENTS:
    "Texts.onboarding-card-updates-required-section-documents",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_KEY_PARTIES:
    "Texts.onboarding-card-updates-required-section-key-parties",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_ADDITIONAL_INFORMATION:
    "Texts.onboarding-card-updates-required-section-additional-information",
  ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_ADDITIONAL_INFORMATION_SUBTITLE:
    "Texts.onboarding-card-updates-required-section-additional-information-subtitle",

  REDIRECT_TO_ISSUER_TITLE: "Texts.redirect-to-issuer-title",
  REDIRECT_TO_ISSUER_BODY: "Texts.redirect-to-issuer-body",
  REDIRECT_TO_ISSUER_CANCEL: "Texts.redirect-to-issuer-cancel",
  REDIRECT_TO_ISSUER_CONTINUE: "Texts.redirect-to-issuer-continue",
  REDIRECT_TO_ISSUER_DO_NOT_ASK_AGAIN:
    "Texts.redirect-to-issuer-do-not-ask-again",

  // Accreditation Modal
  ACCREDITATION_MODAL_TITLE: "Texts.accreditation-modal.title",
  ACCREDITATION_MODAL_TITLE_SUCCESS: "Texts.accreditation-modal.title-success",
  ACCREDITATION_MODAL_TEXT_FIRST: "Texts.accreditation-modal.text-first",
  ACCREDITATION_MODAL_TEXT_FIRST_SUCCESS:
    "Texts.accreditation-modal.text-first-success",
  ACCREDITATION_MODAL_TEXT_SECOND: "Texts.accreditation-modal.text-second",
  ACCREDITATION_MODAL_TEXT_SECOND_SUCCESS:
    "Texts.accreditation-modal.text-second-success",
  ACCREDITATION_MODAL_CHECKBOX_LABEL:
    "Texts.accreditation-modal.checkbox-label",
  ACCREDITATION_MODAL_ERROR_MESSAGE: "Texts.accreditation-modal.error-message",
  ACCREDITATION_MODAL_BUTTONS_CONFIRM:
    "Texts.accreditation-modal.buttons.confirm",
  ACCREDITATION_MODAL_BUTTONS_CANCEL:
    "Texts.accreditation-modal.buttons.cancel",
  ACCREDITATION_MODAL_BUTTONS_UNDERSTOOD:
    "Texts.accreditation-modal.buttons.understood",

  MISSING_ENTITY_TYPE_TITLE: "Texts.missing-entity-type-error-page-title",
  MISSING_ENTITY_TYPE_SUBTITLE: "Texts.missing-entity-type-error-page-subtitle",
  MISSING_ENTITY_TYPE_BUTTON_UPDATING:
    "Texts.missing-entity-type-button-updating",
  MISSING_ENTITY_TYPE_BUTTON_UPDATE: "Texts.missing-entity-type-button-update",
  MISSING_ENTITY_TYPE_PLACEHOLDER: "Texts.missing-entity-type-placeholder",
  MISSING_ENTITY_TYPE_REQUIRED: "Texts.missing-entity-type-required",

  // Download Payout History Modal
  TEXT_PAYOUT_HISTORY_DOWNLOAD_MODAL_TITLE:
    "Text.payout-history.download-modal-title",
  TEXT_PAYOUT_HISTORY_DOWNLOAD_MODAL_DESCRIPTION:
    "Text.payout-history.download-modal-description",
  TEXT_PAYOUT_HISTORY_DOWNLOAD_MODAL_ACTION_1:
    "Text.payout-history.download-modal-action-1",
  TEXT_PAYOUT_HISTORY_DOWNLOAD_MODAL_ACTION_GT1:
    "Text.payout-history.download-modal-action-gt1",
  TEXT_PAYOUT_HISTORY_DOWNLOAD_MODAL_ACTION_DISABLED:
    "Text.payout-history.download-modal-action-disabled",

  // Download Statement Modal
  TEXT_STATEMENT_DOWNLOAD_MODAL_TITLE:
    "Text.investor-statement.download_modal.title",
  TEXT_STATEMENT_DOWNLOAD_MODAL_INPUTS_TITLE:
    "Text.investor-statement.download_modal.inputs-title",
  TEXT_STATEMENT_DOWNLOAD_MODAL_INPUTS_DESCRIPTION:
    "Text.investor-statement.download_modal.inputs-description",
  TEXT_STATEMENT_DOWNLOAD_MODAL_INPUT_START_LABEL:
    "Text.investor-statement.download_modal.input.start-date.label",
  TEXT_STATEMENT_DOWNLOAD_MODAL_INPUT_START_HELPER:
    "Text.investor-statement.download_modal.input.start-date.helper",
  TEXT_STATEMENT_DOWNLOAD_MODAL_INPUT_END_LABEL:
    "Text.investor-statement.download_modal.input.end-date.label",
  TEXT_STATEMENT_DOWNLOAD_MODAL_INPUT_END_HELPER:
    "Text.investor-statement.download_modal.input.end-date.helper",
  TEXT_STATEMENT_DOWNLOAD_MODAL_SECTIONS_TITLE:
    "Text.investor-statement.download_modal.sections.title",
  TEXT_STATEMENT_DOWNLOAD_MODAL_SECTIONS_SUBTITLE:
    "Text.investor-statement.download_modal.sections.subtitle",
  TEXT_STATEMENT_DOWNLOAD_MODAL_SECTIONS_NAME_INVESTMENT_OVERVIEW:
    "Text.investor-statement.download_modal.sections.investment_overview",
  TEXT_STATEMENT_DOWNLOAD_MODAL_SECTIONS_NAME_PERFORMANCE_OVERVIEW:
    "Text.investor-statement.download_modal.sections.performance_overview",
  TEXT_STATEMENT_DOWNLOAD_MODAL_SECTIONS_NAME_CUSTODY_OVERVIEW:
    "Text.investor-statement.download_modal.sections.custody_overview",
  TEXT_STATEMENT_DOWNLOAD_MODAL_SECTIONS_NAME_TRANSACTION_HISTORY:
    "Text.investor-statement.download_modal.sections.transaction_history",
  TEXT_STATEMENT_DOWNLOAD_MODAL_SECTIONS_NAME_PAYOUT_HISTORY:
    "Text.investor-statement.download_modal.sections.payout_history",
  TEXT_STATEMENT_DOWNLOAD_MODAL_BUTTON_SUBMIT:
    "Text.investor-statement.download_modal.button-submit",
  TEXT_STATEMENT_DOWNLOAD_MODAL_FEEDBACK_SUCCESS:
    "Text.investor-statement.download_modal.feedback-success",
  TEXT_STATEMENT_DOWNLOAD_MODAL_FEEDBACK_ERROR:
    "Text.investor-statement.download_modal.feedback-error",
  TEXT_STATEMENT_NO_FILE_AVAILABLE:
    "Texts.asset-performance.download_modal.no-file",

  // Download Transactions Modal
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_MODAL_TITLE:
    "Text.transaction-history.download_modal.title",
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_MODAL_SUBTITLE:
    "Text.transaction-history.download_modal.subtitle",
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_MODAL_INPUT_START_LABEL:
    "Text.transaction-history.download_modal.input.start-date.label",
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_MODAL_INPUT_START_HELPER:
    "Text.transaction-history.download_modal.input.start-date.helper",
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_MODAL_INPUT_END_LABEL:
    "Text.transaction-history.download_modal.input.end-date.label",
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_MODAL_INPUT_END_HELPER:
    "Text.transaction-history.download_modal.input.end-date.helper",
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_CSV:
    "Text.transaction-history.download_button_label_csv",
  TEXT_TRANSACTION_HISTORY_DOWNLOAD_PDF:
    "Text.transaction-history.download_button_label_pdf",
  TEXT_TRANSACTION_DOWNLOAD_NO_FILE_AVAILABLE:
    "Text.transaction-history.download_modal.no-file",

  // BD Terms Modal
  BD_TERMS_MODAL_TITLE: "Texts.bd-terms-modal.title",
  BD_TERMS_MODAL_DESCRIPTION: "Texts.bd-terms-modal.description",
  BD_TERMS_MODAL_ACCEPT: "Texts.bd-terms-modal.accept",
  BD_TERMS_MODAL_ACCEPT_LOADING: "Texts.bd-terms-modal.accept-loading",
  BD_TERMS_MODAL_REJECT: "Texts.bd-terms-modal.reject",

  // Asset Details Header Actions
  ASSET_DETAILS_HEADER_ACTIONS_BUTTON_LABEL:
    "Texts.asset-details-header-actions.button.label",
  ASSET_DETAILS_HEADER_ACTIONS_ACTION_REDEEM:
    "Texts.asset-details-header-actions.actions.redeem-units",
  ASSET_DETAILS_HEADER_ACTIONS_ACTION_REDEEM_TOOLTIP:
    "Texts.asset-details-header-actions.actions.redeem-units.tooltip",
  ASSET_DETAILS_HEADER_ACTIONS_ACTION_DOWNLOAD_PAYOUTS:
    "Texts.asset-details-header-actions.actions.download-payouts",
  ASSET_DETAILS_HEADER_ACTIONS_ACTION_DOWNLOAD_TXS:
    "Texts.asset-details-header-actions.actions.download-transactions",
  ASSET_DETAILS_HEADER_ACTIONS_ACTION_DOWNLOAD_STATEMENT:
    "Texts.asset-details-header-actions.actions.download-statement",

  // ---- Suitability MFE -------------------------------------------------
  // Question/option/section content fields (title/helpText/tooltipText/
  // statement/option.title etc.) carry a TRANSLATION KEY STRING over the
  // wire, not pre-translated text — the backend tells the FE which of these
  // keys applies to a given question/option; the FE still owns the actual
  // copy and resolves it via getTranslation()/<Translate>.
  SUITABILITY_PAGE_TITLE: "Texts.suitability-page-title",
  SUITABILITY_PAGE_SUBTITLE: "Texts.suitability-page-subtitle",
  SUITABILITY_PROGRESS_MESSAGE_STARTED: "Texts.suitability-progress-started",
  SUITABILITY_PROGRESS_MESSAGE_QUARTER: "Texts.suitability-progress-quarter",
  SUITABILITY_PROGRESS_MESSAGE_TWO_THIRDS:
    "Texts.suitability-progress-two-thirds",
  SUITABILITY_PROGRESS_MESSAGE_COMPLETE: "Texts.suitability-progress-complete",
  SUITABILITY_SUBMIT_BUTTON: "Texts.suitability-submit-button",
  SUITABILITY_SUBMIT_BUTTON_LOADING: "Texts.suitability-submit-button-loading",
  SUITABILITY_CONTINUE_BUTTON: "Texts.suitability-continue-button",
  SUITABILITY_CONTINUE_BUTTON_LOADING:
    "Texts.suitability-continue-button-loading",
  SUITABILITY_SUBMIT_SUCCESS: "Texts.suitability-submit-success",
  SUITABILITY_EXIT_BUTTON: "Texts.suitability-exit-button",
  SUITABILITY_VALIDATION_REQUIRED: "Texts.suitability-validation-required",
  SUITABILITY_OPTIONAL_LABEL: "Texts.suitability-optional-label",
  SUITABILITY_MORE_INFO_LABEL: "Texts.suitability-more-info-label",
  SUITABILITY_OPTION_YES: "Texts.suitability-option-yes",
  SUITABILITY_OPTION_NO: "Texts.suitability-option-no",
  SUITABILITY_SECTION_COMPLETED_LABEL:
    "Texts.suitability-section-completed-label",

  SUITABILITY_SECTION_INDUSTRY_TITLE:
    "Texts.suitability-section-industry-title",
  SUITABILITY_SECTION_EDUCATION_TITLE:
    "Texts.suitability-section-education-title",
  SUITABILITY_SECTION_FINANCIAL_TITLE:
    "Texts.suitability-section-financial-title",
  SUITABILITY_SECTION_RISK_PROFILE_TITLE:
    "Texts.suitability-section-risk-profile-title",
  SUITABILITY_SECTION_RISK_CAPACITY_TITLE:
    "Texts.suitability-section-risk-capacity-title",
  SUITABILITY_SECTION_PERSONAL_TITLE:
    "Texts.suitability-section-personal-title",
  SUITABILITY_SECTION_DECLARATIONS_TITLE:
    "Texts.suitability-section-declarations-title",

  SUITABILITY_Q1_LABEL: "Texts.suitability-q1-label",
  SUITABILITY_Q1_HELP: "Texts.suitability-q1-help",
  SUITABILITY_Q1_EMPLOYER_LABEL: "Texts.suitability-q1-employer-label",
  SUITABILITY_Q1_EMPLOYER_HELPER: "Texts.suitability-q1-employer-helper",
  SUITABILITY_Q2_LABEL: "Texts.suitability-q2-label",

  SUITABILITY_Q3_LABEL: "Texts.suitability-q3-label",
  SUITABILITY_Q3_OPTION_BASIC: "Texts.suitability-q3-option-basic",
  SUITABILITY_Q3_OPTION_HIGHSCHOOL: "Texts.suitability-q3-option-highschool",
  SUITABILITY_Q3_OPTION_HIGHER: "Texts.suitability-q3-option-higher",
  SUITABILITY_Q3_OPTION_COLLEGE: "Texts.suitability-q3-option-college",

  SUITABILITY_Q5_LABEL: "Texts.suitability-q5-label",
  SUITABILITY_Q5_OPTION_UNDER_50K: "Texts.suitability-q5-option-under-50k",
  SUITABILITY_Q5_OPTION_50K_100K: "Texts.suitability-q5-option-50k-100k",
  SUITABILITY_Q5_OPTION_100K_250K: "Texts.suitability-q5-option-100k-250k",
  SUITABILITY_Q5_OPTION_OVER_250K: "Texts.suitability-q5-option-over-250k",

  SUITABILITY_Q6_LABEL: "Texts.suitability-q6-label",
  SUITABILITY_Q6_OPTION_UNDER_100K: "Texts.suitability-q6-option-under-100k",
  SUITABILITY_Q6_OPTION_100K_500K: "Texts.suitability-q6-option-100k-500k",
  SUITABILITY_Q6_OPTION_500K_1M: "Texts.suitability-q6-option-500k-1m",
  SUITABILITY_Q6_OPTION_OVER_1M: "Texts.suitability-q6-option-over-1m",

  SUITABILITY_Q7_LABEL: "Texts.suitability-q7-label",
  SUITABILITY_Q7_OPTION_UNDER_10: "Texts.suitability-q7-option-under-10",
  SUITABILITY_Q7_OPTION_10_25: "Texts.suitability-q7-option-10-25",
  SUITABILITY_Q7_OPTION_OVER_25: "Texts.suitability-q7-option-over-25",

  SUITABILITY_Q8_LABEL: "Texts.suitability-q8-label",
  SUITABILITY_Q8_OPTION_CONSERVATIVE:
    "Texts.suitability-q8-option-conservative",
  SUITABILITY_Q8_OPTION_MODERATE: "Texts.suitability-q8-option-moderate",
  SUITABILITY_Q8_OPTION_AGGRESSIVE: "Texts.suitability-q8-option-aggressive",

  SUITABILITY_Q9_LABEL: "Texts.suitability-q9-label",
  SUITABILITY_Q9_OPTION_SHORT: "Texts.suitability-q9-option-short",
  SUITABILITY_Q9_OPTION_MEDIUM: "Texts.suitability-q9-option-medium",
  SUITABILITY_Q9_OPTION_LONG: "Texts.suitability-q9-option-long",

  SUITABILITY_Q10_LABEL: "Texts.suitability-q10-label",
  SUITABILITY_Q10_OPTION_CONSERVATIVE_LABEL:
    "Texts.suitability-q10-option-conservative-label",
  SUITABILITY_Q10_OPTION_CONSERVATIVE_TIER:
    "Texts.suitability-q10-option-conservative-tier",
  SUITABILITY_Q10_OPTION_CONSERVATIVE_DESC:
    "Texts.suitability-q10-option-conservative-desc",
  SUITABILITY_Q10_OPTION_CONSERVATIVE_UNLOCKS:
    "Texts.suitability-q10-option-conservative-unlocks",
  SUITABILITY_Q10_OPTION_MODERATE_LABEL:
    "Texts.suitability-q10-option-moderate-label",
  SUITABILITY_Q10_OPTION_MODERATE_TIER:
    "Texts.suitability-q10-option-moderate-tier",
  SUITABILITY_Q10_OPTION_MODERATE_DESC:
    "Texts.suitability-q10-option-moderate-desc",
  SUITABILITY_Q10_OPTION_MODERATE_UNLOCKS:
    "Texts.suitability-q10-option-moderate-unlocks",
  SUITABILITY_Q10_OPTION_AGGRESSIVE_LABEL:
    "Texts.suitability-q10-option-aggressive-label",
  SUITABILITY_Q10_OPTION_AGGRESSIVE_TIER:
    "Texts.suitability-q10-option-aggressive-tier",
  SUITABILITY_Q10_OPTION_AGGRESSIVE_DESC:
    "Texts.suitability-q10-option-aggressive-desc",
  SUITABILITY_Q10_OPTION_AGGRESSIVE_UNLOCKS:
    "Texts.suitability-q10-option-aggressive-unlocks",

  SUITABILITY_Q11_LABEL: "Texts.suitability-q11-label",
  SUITABILITY_Q11_RESTRICT_HELPER: "Texts.suitability-q11-restrict-helper",

  SUITABILITY_Q12_LABEL: "Texts.suitability-q12-label",
  SUITABILITY_Q12_OPTION_EMPLOYEE: "Texts.suitability-q12-option-employee",
  SUITABILITY_Q12_OPTION_SELF: "Texts.suitability-q12-option-self",
  SUITABILITY_Q12_OPTION_RETIRED: "Texts.suitability-q12-option-retired",
  SUITABILITY_Q12_OPTION_STUDENT: "Texts.suitability-q12-option-student",
  SUITABILITY_Q12_OPTION_UNEMPLOYED: "Texts.suitability-q12-option-unemployed",

  SUITABILITY_Q13_LABEL: "Texts.suitability-q13-label",
  SUITABILITY_Q13_STATEMENT: "Texts.suitability-q13-statement",
  SUITABILITY_Q13_RESTRICT_HELPER: "Texts.suitability-q13-restrict-helper",

  SUITABILITY_Q14_LABEL: "Texts.suitability-q14-label",
  SUITABILITY_Q14_HELP: "Texts.suitability-q14-help",
  SUITABILITY_Q14_TOOLTIP: "Texts.suitability-q14-tooltip",

  SUITABILITY_MATRIX_TITLE: "Texts.suitability-matrix-title",
  SUITABILITY_MATRIX_ASSET_EQUITIES: "Texts.suitability-matrix-asset-equities",
  SUITABILITY_MATRIX_ASSET_EQUITIES_DESC:
    "Texts.suitability-matrix-asset-equities-desc",
  SUITABILITY_MATRIX_ASSET_FIXED_INCOME:
    "Texts.suitability-matrix-asset-fixed-income",
  SUITABILITY_MATRIX_ASSET_FIXED_INCOME_DESC:
    "Texts.suitability-matrix-asset-fixed-income-desc",
  SUITABILITY_MATRIX_ASSET_COLLECTIVE_INVESTMENT:
    "Texts.suitability-matrix-asset-collective-investment",
  SUITABILITY_MATRIX_ASSET_COLLECTIVE_INVESTMENT_DESC:
    "Texts.suitability-matrix-asset-collective-investment-desc",
  SUITABILITY_MATRIX_ASSET_OPTIONS_DERIVATIVES:
    "Texts.suitability-matrix-asset-options-derivatives",
  SUITABILITY_MATRIX_ASSET_OPTIONS_DERIVATIVES_DESC:
    "Texts.suitability-matrix-asset-options-derivatives-desc",
  SUITABILITY_MATRIX_ASSET_DIGITAL_ASSETS:
    "Texts.suitability-matrix-asset-digital-assets",
  SUITABILITY_MATRIX_ASSET_DIGITAL_ASSETS_DESC:
    "Texts.suitability-matrix-asset-digital-assets-desc",
  SUITABILITY_MATRIX_ASSET_PRIVATE_PLACEMENTS_VC:
    "Texts.suitability-matrix-asset-private-placements-vc",
  SUITABILITY_MATRIX_ASSET_PRIVATE_PLACEMENTS_VC_DESC:
    "Texts.suitability-matrix-asset-private-placements-vc-desc",
  SUITABILITY_MATRIX_ASSET_REAL_ESTATE:
    "Texts.suitability-matrix-asset-real-estate",
  SUITABILITY_MATRIX_ASSET_REAL_ESTATE_DESC:
    "Texts.suitability-matrix-asset-real-estate-desc",
  SUITABILITY_MATRIX_DIM_EXPERIENCE_LABEL:
    "Texts.suitability-matrix-dim-experience-label",
  SUITABILITY_MATRIX_DIM_KNOWLEDGE_LABEL:
    "Texts.suitability-matrix-dim-knowledge-label",
  SUITABILITY_MATRIX_DIM_FREQUENCY_LABEL:
    "Texts.suitability-matrix-dim-frequency-label",
  SUITABILITY_MATRIX_LEVEL_NONE: "Texts.suitability-matrix-level-none",
  SUITABILITY_MATRIX_LEVEL_SOME: "Texts.suitability-matrix-level-some",
  SUITABILITY_MATRIX_LEVEL_EXTENSIVE:
    "Texts.suitability-matrix-level-extensive",
  SUITABILITY_MATRIX_FREQ_NEVER: "Texts.suitability-matrix-freq-never",
  SUITABILITY_MATRIX_FREQ_OCCASIONALLY:
    "Texts.suitability-matrix-freq-occasionally",
  SUITABILITY_MATRIX_FREQ_FREQUENTLY:
    "Texts.suitability-matrix-freq-frequently",
  SUITABILITY_MATRIX_VALIDATION_INCOMPLETE:
    "Texts.suitability-matrix-validation-incomplete",

  SUITABILITY_DOC_SUB_NAME: "Texts.suitability-doc-sub-name",
  SUITABILITY_DOC_CRS_NAME: "Texts.suitability-doc-crs-name",
  SUITABILITY_DOCS_INTRO_TITLE: "Texts.suitability-docs-intro-title",
  SUITABILITY_DOCS_INTRO_DESC: "Texts.suitability-docs-intro-desc",
  SUITABILITY_DOCS_OPEN_BUTTON: "Texts.suitability-docs-open-button",
  SUITABILITY_DOCS_OPEN_AGAIN_BUTTON:
    "Texts.suitability-docs-open-again-button",
  SUITABILITY_DOCS_OPENED_LABEL: "Texts.suitability-docs-opened-label",
  SUITABILITY_DOCS_VALIDATION_REQUIRED:
    "Texts.suitability-docs-validation-required",
  SUITABILITY_DOCS_SUB_NAME: "Texts.suitability-docs-sub-name",
  SUITABILITY_DOCS_CRS_NAME: "Texts.suitability-docs-crs-name",

  SUITABILITY_AFFIRMATIONS_TITLE: "Texts.suitability-affirmations-title",
  SUITABILITY_AFFIRMATION_1: "Texts.suitability-affirmation-1",
  SUITABILITY_AFFIRMATION_2: "Texts.suitability-affirmation-2",
  SUITABILITY_AFFIRMATION_3: "Texts.suitability-affirmation-3",
  SUITABILITY_AFFIRMATION_4: "Texts.suitability-affirmation-4",
  SUITABILITY_CONFIRM_CHECKBOX_LABEL:
    "Texts.suitability-confirm-checkbox-label",
  SUITABILITY_CONFIRM_CHECKBOX_SUBTITLE:
    "Texts.suitability-confirm-checkbox-subtitle",
  SUITABILITY_CONFIRM_CHECKBOX_HELPER:
    "Texts.suitability-confirm-checkbox-helper",
  SUITABILITY_CONFIRM_BLOCKED_ERROR: "Texts.suitability-confirm-blocked-error",
  SUITABILITY_CONFIRM_VALIDATION_REQUIRED:
    "Texts.suitability-confirm-validation-required",

  SUITABILITY_DLT_TITLE: "Texts.suitability-dlt-title",
  SUITABILITY_DLT_INTRO: "Texts.suitability-dlt-intro",
  SUITABILITY_DLT_LEARN_LINK_LABEL: "Texts.suitability-dlt-learn-link-label",
  SUITABILITY_DLT_ANSWERED_COUNT: "Texts.suitability-dlt-answered-count",
  SUITABILITY_DLT_RETRY_TITLE: "Texts.suitability-dlt-retry-title",
  SUITABILITY_DLT_RETRY_BODY: "Texts.suitability-dlt-retry-body",
  SUITABILITY_DLT_LOCKED_TITLE: "Texts.suitability-dlt-locked-title",
  SUITABILITY_DLT_LOCKED_BODY: "Texts.suitability-dlt-locked-body",
  SUITABILITY_DLT_CONTACT_SUPPORT: "Texts.suitability-dlt-contact-support",
  SUITABILITY_DLT_BACK_BUTTON: "Texts.suitability-dlt-back-button",
  SUITABILITY_DLT_SUBMIT_BUTTON: "Texts.suitability-dlt-submit-button",
  SUITABILITY_DLT_SUBMIT_BUTTON_LOADING:
    "Texts.suitability-dlt-submit-button-loading",
  SUITABILITY_DLT_VALIDATION_REQUIRED:
    "Texts.suitability-dlt-validation-required",
  SUITABILITY_DLT_LAST_STEP_NOTE: "Texts.suitability-dlt-last-step-note",

  SUITABILITY_DLT_GROUP_TITLE: "Texts.suitability-dlt-group-title",
  SUITABILITY_DLT_Q1_TITLE: "Texts.suitability-dlt-q1-title",
  SUITABILITY_DLT_Q1_OPTION_0: "Texts.suitability-dlt-q1-option-0",
  SUITABILITY_DLT_Q1_OPTION_1: "Texts.suitability-dlt-q1-option-1",
  SUITABILITY_DLT_Q1_OPTION_2: "Texts.suitability-dlt-q1-option-2",
  SUITABILITY_DLT_Q1_OPTION_3: "Texts.suitability-dlt-q1-option-3",
  SUITABILITY_DLT_Q2_TITLE: "Texts.suitability-dlt-q2-title",
  SUITABILITY_DLT_Q2_OPTION_0: "Texts.suitability-dlt-q2-option-0",
  SUITABILITY_DLT_Q2_OPTION_1: "Texts.suitability-dlt-q2-option-1",
  SUITABILITY_DLT_Q2_OPTION_2: "Texts.suitability-dlt-q2-option-2",
  SUITABILITY_DLT_Q2_OPTION_3: "Texts.suitability-dlt-q2-option-3",
  SUITABILITY_DLT_Q3_TITLE: "Texts.suitability-dlt-q3-title",
  SUITABILITY_DLT_Q3_OPTION_0: "Texts.suitability-dlt-q3-option-0",
  SUITABILITY_DLT_Q3_OPTION_1: "Texts.suitability-dlt-q3-option-1",
  SUITABILITY_DLT_Q3_OPTION_2: "Texts.suitability-dlt-q3-option-2",
  SUITABILITY_DLT_Q3_OPTION_3: "Texts.suitability-dlt-q3-option-3",
  SUITABILITY_DLT_Q4_TITLE: "Texts.suitability-dlt-q4-title",
  SUITABILITY_DLT_Q4_OPTION_0: "Texts.suitability-dlt-q4-option-0",
  SUITABILITY_DLT_Q4_OPTION_1: "Texts.suitability-dlt-q4-option-1",
  SUITABILITY_DLT_Q4_OPTION_2: "Texts.suitability-dlt-q4-option-2",
  SUITABILITY_DLT_Q4_OPTION_3: "Texts.suitability-dlt-q4-option-3",
  SUITABILITY_DLT_Q5_TITLE: "Texts.suitability-dlt-q5-title",
  SUITABILITY_DLT_Q5_OPTION_0: "Texts.suitability-dlt-q5-option-0",
  SUITABILITY_DLT_Q5_OPTION_1: "Texts.suitability-dlt-q5-option-1",
  SUITABILITY_DLT_Q5_OPTION_2: "Texts.suitability-dlt-q5-option-2",
  SUITABILITY_DLT_Q5_OPTION_3: "Texts.suitability-dlt-q5-option-3",
  SUITABILITY_DLT_Q6_TITLE: "Texts.suitability-dlt-q6-title",
  SUITABILITY_DLT_Q6_OPTION_0: "Texts.suitability-dlt-q6-option-0",
  SUITABILITY_DLT_Q6_OPTION_1: "Texts.suitability-dlt-q6-option-1",
  SUITABILITY_DLT_Q6_OPTION_2: "Texts.suitability-dlt-q6-option-2",
  SUITABILITY_DLT_Q6_OPTION_3: "Texts.suitability-dlt-q6-option-3",
  SUITABILITY_DLT_Q7_TITLE: "Texts.suitability-dlt-q7-title",
  SUITABILITY_DLT_Q7_OPTION_0: "Texts.suitability-dlt-q7-option-0",
  SUITABILITY_DLT_Q7_OPTION_1: "Texts.suitability-dlt-q7-option-1",
  SUITABILITY_DLT_Q7_OPTION_2: "Texts.suitability-dlt-q7-option-2",
  SUITABILITY_DLT_Q7_OPTION_3: "Texts.suitability-dlt-q7-option-3",
  SUITABILITY_DLT_Q8_TITLE: "Texts.suitability-dlt-q8-title",
  SUITABILITY_DLT_Q8_OPTION_0: "Texts.suitability-dlt-q8-option-0",
  SUITABILITY_DLT_Q8_OPTION_1: "Texts.suitability-dlt-q8-option-1",
  SUITABILITY_DLT_Q8_OPTION_2: "Texts.suitability-dlt-q8-option-2",
  SUITABILITY_DLT_Q8_OPTION_3: "Texts.suitability-dlt-q8-option-3",

  SUITABILITY_WARNING_AGGRESSIVE_ZERO_LOSS:
    "Texts.suitability-warning-aggressive-zero-loss",
  SUITABILITY_WARNING_PRESERVATION_HIGH_LOSS:
    "Texts.suitability-warning-preservation-high-loss",
  SUITABILITY_WARNING_SHORT_HORIZON_HIGH_LOSS:
    "Texts.suitability-warning-short-horizon-high-loss",

  SUITABILITY_EXIT_MODAL_TITLE: "Texts.suitability-exit-modal-title",
  SUITABILITY_EXIT_MODAL_BODY: "Texts.suitability-exit-modal-body",
  SUITABILITY_EXIT_MODAL_KEEP_GOING: "Texts.suitability-exit-modal-keep-going",
  SUITABILITY_EXIT_MODAL_LEAVE: "Texts.suitability-exit-modal-leave",
} as const;

export default translationKeys;

export type TranslationKey =
  (typeof translationKeys)[keyof typeof translationKeys];

export function getDocumentTypeTranslationKeys(documentType: string) {
  return {
    name: `Texts.document.${documentType}.name` as TranslationKey,
    description: `Texts.document.${documentType}.description` as TranslationKey,
  };
}

export const entityTypesTranslations = Object.fromEntries(
  Object.values(SID.InvestorEntityTypes).map((type) => [
    type,
    `Texts.profile-entity-types-${type}` satisfies TranslationKey,
  ]),
) as Record<SID.InvestorEntityType, TranslationKey>;
